import './scss/main.scss';

'use strict';

/* Global Variables and Functions */
const ajaxurl = '/wp-admin/admin-ajax.php';

function updateURLParameter(url, param, paramVal) {
    let newAdditionalURL = '';
    let tempArray = url.split('?');
    const baseURL = tempArray[0];
    const additionalURL = tempArray[1];
    let temp = '';
    if (additionalURL) {
        tempArray = additionalURL.split("&");
        for (let i = 0; i < tempArray.length; i++){
            if(tempArray[i].split('=')[0] != param){
                newAdditionalURL += temp + tempArray[i];
                temp = '&';
            }
        }
    }

    const rows_txt = temp + '' + param + '=' + paramVal;
    return baseURL + '?' + newAdditionalURL + rows_txt;
}

function removeURLParameter(url){
    return url.split(/[?#]/)[0];
}

function changeUrl(parameter, id) {
    const currentUrl = window.location.href;
    window.history.replaceState('', '', updateURLParameter(currentUrl, parameter, id));
}

function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

/* JS Start when Document Load & DOM build*/
document.addEventListener('DOMContentLoaded', ready);
function ready() {};

/* ==========================================================================
* jQuery Scripts
* ========================================================================== */
(function($){
    $(document).ready(function() {

        /* Format Time to AM PM */
        function formatAMPM(date) {
            let hours = date.getHours();
            let minutes = date.getMinutes();
            let ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0'+minutes : minutes;
            const strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        }

        function isInt(n) {
            return n % 1 === 0;
        }

        $('.js-updated-at').text(formatAMPM(new Date))

        /* Crypto Conversion Calculator */
        let cryptoStatus = global_vars.crypto_data.status;

        if (cryptoStatus.error_code) {

            console.error(cryptoStatus.error_message)
            console.log(cryptoStatus.notice)

            $('.calculator').text('Sorry, an error occurred.');
            $('.calculator').css('color', 'red');

        } else {

            let cryptoData = global_vars.crypto_data.data;

            let cryptoDataDummy = {
                "BCH": [
                    {
                        "id": 1794,
                        "name": "a840dvj3i6o",
                        "symbol": "BCH",
                        "slug": "4yh8wgnht7",
                        "is_active": 6362,
                        "is_fiat": null,
                        "circulating_supply": 8080,
                        "total_supply": 2465,
                        "max_supply": 5015,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 5340,
                        "cmc_rank": 8852,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "8gdcz3rgw0a",
                            "t8l80hj4k7k",
                            "b7q5ooqkqhv",
                            "wrb3b5n9i2",
                            "w2wzfcrjio",
                            "hmyo15uk4mn",
                            "q1ittuweien",
                            "xs0pbxbhyx",
                            "gvt7ajytdoh",
                            "1j38ffhliku"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.6904036711494652,
                                "volume_24h": 0.828376821386551,
                                "volume_change_24h": 0.8473128957112284,
                                "percent_change_1h": 0.34667555441822095,
                                "percent_change_24h": 0.9529121460591983,
                                "percent_change_7d": 0.06635460056985654,
                                "percent_change_30d": 0.5198402880244035,
                                "market_cap": 0.8587929374503882,
                                "market_cap_dominance": 9332,
                                "fully_diluted_market_cap": 0.3817364371027021,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.6904036711494652,
                                "volume_24h": 0.828376821386551,
                                "volume_change_24h": 0.8473128957112284,
                                "percent_change_1h": 0.34667555441822095,
                                "percent_change_24h": 0.9529121460591983,
                                "percent_change_7d": 0.06635460056985654,
                                "percent_change_30d": 0.5198402880244035,
                                "market_cap": 0.8587929374503882,
                                "market_cap_dominance": 9332,
                                "fully_diluted_market_cap": 0.3817364371027021,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.6904036711494652,
                                "volume_24h": 0.828376821386551,
                                "volume_change_24h": 0.8473128957112284,
                                "percent_change_1h": 0.34667555441822095,
                                "percent_change_24h": 0.9529121460591983,
                                "percent_change_7d": 0.06635460056985654,
                                "percent_change_30d": 0.5198402880244035,
                                "market_cap": 0.8587929374503882,
                                "market_cap_dominance": 9332,
                                "fully_diluted_market_cap": 0.3817364371027021,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.6904036711494652,
                                "volume_24h": 0.828376821386551,
                                "volume_change_24h": 0.8473128957112284,
                                "percent_change_1h": 0.34667555441822095,
                                "percent_change_24h": 0.9529121460591983,
                                "percent_change_7d": 0.06635460056985654,
                                "percent_change_30d": 0.5198402880244035,
                                "market_cap": 0.8587929374503882,
                                "market_cap_dominance": 9332,
                                "fully_diluted_market_cap": 0.3817364371027021,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.6904036711494652,
                                "volume_24h": 0.828376821386551,
                                "volume_change_24h": 0.8473128957112284,
                                "percent_change_1h": 0.34667555441822095,
                                "percent_change_24h": 0.9529121460591983,
                                "percent_change_7d": 0.06635460056985654,
                                "percent_change_30d": 0.5198402880244035,
                                "market_cap": 0.8587929374503882,
                                "market_cap_dominance": 9332,
                                "fully_diluted_market_cap": 0.3817364371027021,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.6904036711494652,
                                "volume_24h": 0.828376821386551,
                                "volume_change_24h": 0.8473128957112284,
                                "percent_change_1h": 0.34667555441822095,
                                "percent_change_24h": 0.9529121460591983,
                                "percent_change_7d": 0.06635460056985654,
                                "percent_change_30d": 0.5198402880244035,
                                "market_cap": 0.8587929374503882,
                                "market_cap_dominance": 9332,
                                "fully_diluted_market_cap": 0.3817364371027021,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.6904036711494652,
                                "volume_24h": 0.828376821386551,
                                "volume_change_24h": 0.8473128957112284,
                                "percent_change_1h": 0.34667555441822095,
                                "percent_change_24h": 0.9529121460591983,
                                "percent_change_7d": 0.06635460056985654,
                                "percent_change_30d": 0.5198402880244035,
                                "market_cap": 0.8587929374503882,
                                "market_cap_dominance": 9332,
                                "fully_diluted_market_cap": 0.3817364371027021,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 521,
                        "name": "plqupodo5mo",
                        "symbol": "BCH",
                        "slug": "injtuhwrt1",
                        "is_active": 964,
                        "is_fiat": null,
                        "circulating_supply": 9556,
                        "total_supply": 3846,
                        "max_supply": 2990,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 4836,
                        "cmc_rank": 690,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "oim53hewaoa",
                            "t233zdmfzco",
                            "ma60ckcl7eo",
                            "oiwqderef3f",
                            "x4pvswc2nfa",
                            "swq6604ekn",
                            "sovukvd4bwl",
                            "oew1160y9e",
                            "ahduo1ceyf",
                            "fxvc5rmvrwo"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.7499704976488566,
                                "volume_24h": 0.3544451687956811,
                                "volume_change_24h": 0.08996867495198613,
                                "percent_change_1h": 0.3498528097899667,
                                "percent_change_24h": 0.7943776277164258,
                                "percent_change_7d": 0.21298618816521175,
                                "percent_change_30d": 0.7223631465870011,
                                "market_cap": 0.959448395276284,
                                "market_cap_dominance": 5358,
                                "fully_diluted_market_cap": 0.5004565700243047,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.7499704976488566,
                                "volume_24h": 0.3544451687956811,
                                "volume_change_24h": 0.08996867495198613,
                                "percent_change_1h": 0.3498528097899667,
                                "percent_change_24h": 0.7943776277164258,
                                "percent_change_7d": 0.21298618816521175,
                                "percent_change_30d": 0.7223631465870011,
                                "market_cap": 0.959448395276284,
                                "market_cap_dominance": 5358,
                                "fully_diluted_market_cap": 0.5004565700243047,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.7499704976488566,
                                "volume_24h": 0.3544451687956811,
                                "volume_change_24h": 0.08996867495198613,
                                "percent_change_1h": 0.3498528097899667,
                                "percent_change_24h": 0.7943776277164258,
                                "percent_change_7d": 0.21298618816521175,
                                "percent_change_30d": 0.7223631465870011,
                                "market_cap": 0.959448395276284,
                                "market_cap_dominance": 5358,
                                "fully_diluted_market_cap": 0.5004565700243047,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.7499704976488566,
                                "volume_24h": 0.3544451687956811,
                                "volume_change_24h": 0.08996867495198613,
                                "percent_change_1h": 0.3498528097899667,
                                "percent_change_24h": 0.7943776277164258,
                                "percent_change_7d": 0.21298618816521175,
                                "percent_change_30d": 0.7223631465870011,
                                "market_cap": 0.959448395276284,
                                "market_cap_dominance": 5358,
                                "fully_diluted_market_cap": 0.5004565700243047,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.7499704976488566,
                                "volume_24h": 0.3544451687956811,
                                "volume_change_24h": 0.08996867495198613,
                                "percent_change_1h": 0.3498528097899667,
                                "percent_change_24h": 0.7943776277164258,
                                "percent_change_7d": 0.21298618816521175,
                                "percent_change_30d": 0.7223631465870011,
                                "market_cap": 0.959448395276284,
                                "market_cap_dominance": 5358,
                                "fully_diluted_market_cap": 0.5004565700243047,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.7499704976488566,
                                "volume_24h": 0.3544451687956811,
                                "volume_change_24h": 0.08996867495198613,
                                "percent_change_1h": 0.3498528097899667,
                                "percent_change_24h": 0.7943776277164258,
                                "percent_change_7d": 0.21298618816521175,
                                "percent_change_30d": 0.7223631465870011,
                                "market_cap": 0.959448395276284,
                                "market_cap_dominance": 5358,
                                "fully_diluted_market_cap": 0.5004565700243047,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.7499704976488566,
                                "volume_24h": 0.3544451687956811,
                                "volume_change_24h": 0.08996867495198613,
                                "percent_change_1h": 0.3498528097899667,
                                "percent_change_24h": 0.7943776277164258,
                                "percent_change_7d": 0.21298618816521175,
                                "percent_change_30d": 0.7223631465870011,
                                "market_cap": 0.959448395276284,
                                "market_cap_dominance": 5358,
                                "fully_diluted_market_cap": 0.5004565700243047,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 3496,
                        "name": "ddpdmk7c1vq",
                        "symbol": "BCH",
                        "slug": "6rnfzwhg7ns",
                        "is_active": 4302,
                        "is_fiat": null,
                        "circulating_supply": 7159,
                        "total_supply": 5280,
                        "max_supply": 1313,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 9202,
                        "cmc_rank": 8456,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "guh032dhgk",
                            "egfba07ysse",
                            "826x0hm84bj",
                            "ickly8eer6",
                            "t961bu592o",
                            "dg5ipm1urm",
                            "hfd2tpy67a",
                            "ro2hcvl33x",
                            "30h7hxx3e0r",
                            "chavv5jjys7"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.42053653580234696,
                                "volume_24h": 0.02588608385200497,
                                "volume_change_24h": 0.8287567762333894,
                                "percent_change_1h": 0.21915148691046027,
                                "percent_change_24h": 0.399221603759071,
                                "percent_change_7d": 0.0033927406027163265,
                                "percent_change_30d": 0.014641928171116536,
                                "market_cap": 0.586990902732871,
                                "market_cap_dominance": 8965,
                                "fully_diluted_market_cap": 0.7087671489968386,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.42053653580234696,
                                "volume_24h": 0.02588608385200497,
                                "volume_change_24h": 0.8287567762333894,
                                "percent_change_1h": 0.21915148691046027,
                                "percent_change_24h": 0.399221603759071,
                                "percent_change_7d": 0.0033927406027163265,
                                "percent_change_30d": 0.014641928171116536,
                                "market_cap": 0.586990902732871,
                                "market_cap_dominance": 8965,
                                "fully_diluted_market_cap": 0.7087671489968386,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.42053653580234696,
                                "volume_24h": 0.02588608385200497,
                                "volume_change_24h": 0.8287567762333894,
                                "percent_change_1h": 0.21915148691046027,
                                "percent_change_24h": 0.399221603759071,
                                "percent_change_7d": 0.0033927406027163265,
                                "percent_change_30d": 0.014641928171116536,
                                "market_cap": 0.586990902732871,
                                "market_cap_dominance": 8965,
                                "fully_diluted_market_cap": 0.7087671489968386,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.42053653580234696,
                                "volume_24h": 0.02588608385200497,
                                "volume_change_24h": 0.8287567762333894,
                                "percent_change_1h": 0.21915148691046027,
                                "percent_change_24h": 0.399221603759071,
                                "percent_change_7d": 0.0033927406027163265,
                                "percent_change_30d": 0.014641928171116536,
                                "market_cap": 0.586990902732871,
                                "market_cap_dominance": 8965,
                                "fully_diluted_market_cap": 0.7087671489968386,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.42053653580234696,
                                "volume_24h": 0.02588608385200497,
                                "volume_change_24h": 0.8287567762333894,
                                "percent_change_1h": 0.21915148691046027,
                                "percent_change_24h": 0.399221603759071,
                                "percent_change_7d": 0.0033927406027163265,
                                "percent_change_30d": 0.014641928171116536,
                                "market_cap": 0.586990902732871,
                                "market_cap_dominance": 8965,
                                "fully_diluted_market_cap": 0.7087671489968386,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.42053653580234696,
                                "volume_24h": 0.02588608385200497,
                                "volume_change_24h": 0.8287567762333894,
                                "percent_change_1h": 0.21915148691046027,
                                "percent_change_24h": 0.399221603759071,
                                "percent_change_7d": 0.0033927406027163265,
                                "percent_change_30d": 0.014641928171116536,
                                "market_cap": 0.586990902732871,
                                "market_cap_dominance": 8965,
                                "fully_diluted_market_cap": 0.7087671489968386,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.42053653580234696,
                                "volume_24h": 0.02588608385200497,
                                "volume_change_24h": 0.8287567762333894,
                                "percent_change_1h": 0.21915148691046027,
                                "percent_change_24h": 0.399221603759071,
                                "percent_change_7d": 0.0033927406027163265,
                                "percent_change_30d": 0.014641928171116536,
                                "market_cap": 0.586990902732871,
                                "market_cap_dominance": 8965,
                                "fully_diluted_market_cap": 0.7087671489968386,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    }
                ],
                "BTC": [
                    {
                        "id": 7600,
                        "name": "az0aftyio1k",
                        "symbol": "BTC",
                        "slug": "7l6fkkv9qmu",
                        "is_active": 3688,
                        "is_fiat": null,
                        "circulating_supply": 6733,
                        "total_supply": 4869,
                        "max_supply": 9097,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 3065,
                        "cmc_rank": 4447,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "xou4ef4xztf",
                            "5huwykxh9cs",
                            "95iqdk8mzb",
                            "9qcochwr3u",
                            "fnsz7oxhoa",
                            "imdygl2ablr",
                            "jh6z149h6y",
                            "a70v57dmtt",
                            "acvf5bbk6gd",
                            "emitps7m34h"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 1,
                                "volume_24h": 0.22852256710764163,
                                "volume_change_24h": 0.08191660089042596,
                                "percent_change_1h": 0.6154154184983058,
                                "percent_change_24h": 0.5809015174274013,
                                "percent_change_7d": 0.6310611556747765,
                                "percent_change_30d": 0.41072086809041775,
                                "market_cap": 0.12115238219037416,
                                "market_cap_dominance": 7546,
                                "fully_diluted_market_cap": 0.7787102579450207,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 2,
                                "volume_24h": 0.22852256710764163,
                                "volume_change_24h": 0.08191660089042596,
                                "percent_change_1h": 0.6154154184983058,
                                "percent_change_24h": 0.5809015174274013,
                                "percent_change_7d": 0.6310611556747765,
                                "percent_change_30d": 0.41072086809041775,
                                "market_cap": 0.12115238219037416,
                                "market_cap_dominance": 7546,
                                "fully_diluted_market_cap": 0.7787102579450207,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 3,
                                "volume_24h": 0.22852256710764163,
                                "volume_change_24h": 0.08191660089042596,
                                "percent_change_1h": 0.6154154184983058,
                                "percent_change_24h": 0.5809015174274013,
                                "percent_change_7d": 0.6310611556747765,
                                "percent_change_30d": 0.41072086809041775,
                                "market_cap": 0.12115238219037416,
                                "market_cap_dominance": 7546,
                                "fully_diluted_market_cap": 0.7787102579450207,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.43190518730088145,
                                "volume_24h": 0.22852256710764163,
                                "volume_change_24h": 0.08191660089042596,
                                "percent_change_1h": 0.6154154184983058,
                                "percent_change_24h": 0.5809015174274013,
                                "percent_change_7d": 0.6310611556747765,
                                "percent_change_30d": 0.41072086809041775,
                                "market_cap": 0.12115238219037416,
                                "market_cap_dominance": 7546,
                                "fully_diluted_market_cap": 0.7787102579450207,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.43190518730088145,
                                "volume_24h": 0.22852256710764163,
                                "volume_change_24h": 0.08191660089042596,
                                "percent_change_1h": 0.6154154184983058,
                                "percent_change_24h": 0.5809015174274013,
                                "percent_change_7d": 0.6310611556747765,
                                "percent_change_30d": 0.41072086809041775,
                                "market_cap": 0.12115238219037416,
                                "market_cap_dominance": 7546,
                                "fully_diluted_market_cap": 0.7787102579450207,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.43190518730088145,
                                "volume_24h": 0.22852256710764163,
                                "volume_change_24h": 0.08191660089042596,
                                "percent_change_1h": 0.6154154184983058,
                                "percent_change_24h": 0.5809015174274013,
                                "percent_change_7d": 0.6310611556747765,
                                "percent_change_30d": 0.41072086809041775,
                                "market_cap": 0.12115238219037416,
                                "market_cap_dominance": 7546,
                                "fully_diluted_market_cap": 0.7787102579450207,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.43190518730088145,
                                "volume_24h": 0.22852256710764163,
                                "volume_change_24h": 0.08191660089042596,
                                "percent_change_1h": 0.6154154184983058,
                                "percent_change_24h": 0.5809015174274013,
                                "percent_change_7d": 0.6310611556747765,
                                "percent_change_30d": 0.41072086809041775,
                                "market_cap": 0.12115238219037416,
                                "market_cap_dominance": 7546,
                                "fully_diluted_market_cap": 0.7787102579450207,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 4841,
                        "name": "5k6mxpmbze9",
                        "symbol": "BTC",
                        "slug": "7rdibkvx7d9",
                        "is_active": 5944,
                        "is_fiat": null,
                        "circulating_supply": 2721,
                        "total_supply": 8635,
                        "max_supply": 208,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 4367,
                        "cmc_rank": 148,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "urn30hcqm9",
                            "37yggkjt9pq",
                            "ylp2wys59um",
                            "f3iwkchbpx7",
                            "9vbtz0sm19",
                            "v2w4wkw8gr8",
                            "rs9cdqpnc",
                            "tei6ejt4f8",
                            "y7ll8tzgu0b",
                            "2t1bxdx2ag4"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.2670535617212175,
                                "volume_24h": 0.8965324993108192,
                                "volume_change_24h": 0.25182961004804283,
                                "percent_change_1h": 0.0506035876474662,
                                "percent_change_24h": 0.9678251423192252,
                                "percent_change_7d": 0.04004632749863202,
                                "percent_change_30d": 0.26250812350348807,
                                "market_cap": 0.5896568147006287,
                                "market_cap_dominance": 5052,
                                "fully_diluted_market_cap": 0.6143465688823819,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.2670535617212175,
                                "volume_24h": 0.8965324993108192,
                                "volume_change_24h": 0.25182961004804283,
                                "percent_change_1h": 0.0506035876474662,
                                "percent_change_24h": 0.9678251423192252,
                                "percent_change_7d": 0.04004632749863202,
                                "percent_change_30d": 0.26250812350348807,
                                "market_cap": 0.5896568147006287,
                                "market_cap_dominance": 5052,
                                "fully_diluted_market_cap": 0.6143465688823819,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.2670535617212175,
                                "volume_24h": 0.8965324993108192,
                                "volume_change_24h": 0.25182961004804283,
                                "percent_change_1h": 0.0506035876474662,
                                "percent_change_24h": 0.9678251423192252,
                                "percent_change_7d": 0.04004632749863202,
                                "percent_change_30d": 0.26250812350348807,
                                "market_cap": 0.5896568147006287,
                                "market_cap_dominance": 5052,
                                "fully_diluted_market_cap": 0.6143465688823819,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.2670535617212175,
                                "volume_24h": 0.8965324993108192,
                                "volume_change_24h": 0.25182961004804283,
                                "percent_change_1h": 0.0506035876474662,
                                "percent_change_24h": 0.9678251423192252,
                                "percent_change_7d": 0.04004632749863202,
                                "percent_change_30d": 0.26250812350348807,
                                "market_cap": 0.5896568147006287,
                                "market_cap_dominance": 5052,
                                "fully_diluted_market_cap": 0.6143465688823819,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.2670535617212175,
                                "volume_24h": 0.8965324993108192,
                                "volume_change_24h": 0.25182961004804283,
                                "percent_change_1h": 0.0506035876474662,
                                "percent_change_24h": 0.9678251423192252,
                                "percent_change_7d": 0.04004632749863202,
                                "percent_change_30d": 0.26250812350348807,
                                "market_cap": 0.5896568147006287,
                                "market_cap_dominance": 5052,
                                "fully_diluted_market_cap": 0.6143465688823819,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.2670535617212175,
                                "volume_24h": 0.8965324993108192,
                                "volume_change_24h": 0.25182961004804283,
                                "percent_change_1h": 0.0506035876474662,
                                "percent_change_24h": 0.9678251423192252,
                                "percent_change_7d": 0.04004632749863202,
                                "percent_change_30d": 0.26250812350348807,
                                "market_cap": 0.5896568147006287,
                                "market_cap_dominance": 5052,
                                "fully_diluted_market_cap": 0.6143465688823819,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.2670535617212175,
                                "volume_24h": 0.8965324993108192,
                                "volume_change_24h": 0.25182961004804283,
                                "percent_change_1h": 0.0506035876474662,
                                "percent_change_24h": 0.9678251423192252,
                                "percent_change_7d": 0.04004632749863202,
                                "percent_change_30d": 0.26250812350348807,
                                "market_cap": 0.5896568147006287,
                                "market_cap_dominance": 5052,
                                "fully_diluted_market_cap": 0.6143465688823819,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 2032,
                        "name": "besd95vme4k",
                        "symbol": "BTC",
                        "slug": "fev3h17rs5",
                        "is_active": 5051,
                        "is_fiat": null,
                        "circulating_supply": 8922,
                        "total_supply": 3590,
                        "max_supply": 4090,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 1186,
                        "cmc_rank": 7946,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "k02h7s5i3lj",
                            "rfqcwft96wo",
                            "zjm5sf2fwbs",
                            "xb6gn0x6268",
                            "kx9xl6sqd78",
                            "k08b69wmo3e",
                            "at928x6v2c6",
                            "pcy3z2lkrac",
                            "j6dvfzkoma",
                            "7u2db9e4wzd"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.015402047009164033,
                                "volume_24h": 0.08862353999219175,
                                "volume_change_24h": 0.977208964256052,
                                "percent_change_1h": 0.4633811238346002,
                                "percent_change_24h": 0.5352122809446394,
                                "percent_change_7d": 0.9375250412309897,
                                "percent_change_30d": 0.4400659844579786,
                                "market_cap": 0.6738981214245434,
                                "market_cap_dominance": 980,
                                "fully_diluted_market_cap": 0.7647001102172193,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.015402047009164033,
                                "volume_24h": 0.08862353999219175,
                                "volume_change_24h": 0.977208964256052,
                                "percent_change_1h": 0.4633811238346002,
                                "percent_change_24h": 0.5352122809446394,
                                "percent_change_7d": 0.9375250412309897,
                                "percent_change_30d": 0.4400659844579786,
                                "market_cap": 0.6738981214245434,
                                "market_cap_dominance": 980,
                                "fully_diluted_market_cap": 0.7647001102172193,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.015402047009164033,
                                "volume_24h": 0.08862353999219175,
                                "volume_change_24h": 0.977208964256052,
                                "percent_change_1h": 0.4633811238346002,
                                "percent_change_24h": 0.5352122809446394,
                                "percent_change_7d": 0.9375250412309897,
                                "percent_change_30d": 0.4400659844579786,
                                "market_cap": 0.6738981214245434,
                                "market_cap_dominance": 980,
                                "fully_diluted_market_cap": 0.7647001102172193,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.015402047009164033,
                                "volume_24h": 0.08862353999219175,
                                "volume_change_24h": 0.977208964256052,
                                "percent_change_1h": 0.4633811238346002,
                                "percent_change_24h": 0.5352122809446394,
                                "percent_change_7d": 0.9375250412309897,
                                "percent_change_30d": 0.4400659844579786,
                                "market_cap": 0.6738981214245434,
                                "market_cap_dominance": 980,
                                "fully_diluted_market_cap": 0.7647001102172193,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.015402047009164033,
                                "volume_24h": 0.08862353999219175,
                                "volume_change_24h": 0.977208964256052,
                                "percent_change_1h": 0.4633811238346002,
                                "percent_change_24h": 0.5352122809446394,
                                "percent_change_7d": 0.9375250412309897,
                                "percent_change_30d": 0.4400659844579786,
                                "market_cap": 0.6738981214245434,
                                "market_cap_dominance": 980,
                                "fully_diluted_market_cap": 0.7647001102172193,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.015402047009164033,
                                "volume_24h": 0.08862353999219175,
                                "volume_change_24h": 0.977208964256052,
                                "percent_change_1h": 0.4633811238346002,
                                "percent_change_24h": 0.5352122809446394,
                                "percent_change_7d": 0.9375250412309897,
                                "percent_change_30d": 0.4400659844579786,
                                "market_cap": 0.6738981214245434,
                                "market_cap_dominance": 980,
                                "fully_diluted_market_cap": 0.7647001102172193,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.015402047009164033,
                                "volume_24h": 0.08862353999219175,
                                "volume_change_24h": 0.977208964256052,
                                "percent_change_1h": 0.4633811238346002,
                                "percent_change_24h": 0.5352122809446394,
                                "percent_change_7d": 0.9375250412309897,
                                "percent_change_30d": 0.4400659844579786,
                                "market_cap": 0.6738981214245434,
                                "market_cap_dominance": 980,
                                "fully_diluted_market_cap": 0.7647001102172193,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    }
                ],
                "BUSD": [
                    {
                        "id": 4103,
                        "name": "b5j5pkmhbaq",
                        "symbol": "BUSD",
                        "slug": "9erq2kgavi5",
                        "is_active": 3277,
                        "is_fiat": null,
                        "circulating_supply": 7743,
                        "total_supply": 1866,
                        "max_supply": 1332,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 5017,
                        "cmc_rank": 3076,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "btxx4s7j8jv",
                            "19t3rw6tv6o",
                            "yv8srct9xt",
                            "fqqsxu51oih",
                            "kop8cxew0yd",
                            "6o9mdckfprb",
                            "922g7wx89zo",
                            "2k0hrb8qtvp",
                            "kcav709juz",
                            "9giypiy2ure"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.462455707380915,
                                "volume_24h": 0.8999713450982219,
                                "volume_change_24h": 0.9170050000673493,
                                "percent_change_1h": 0.4276960351729284,
                                "percent_change_24h": 0.1781153279100538,
                                "percent_change_7d": 0.640773402956385,
                                "percent_change_30d": 0.9122380465730993,
                                "market_cap": 0.48390522151163107,
                                "market_cap_dominance": 4623,
                                "fully_diluted_market_cap": 0.31974987519224274,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.462455707380915,
                                "volume_24h": 0.8999713450982219,
                                "volume_change_24h": 0.9170050000673493,
                                "percent_change_1h": 0.4276960351729284,
                                "percent_change_24h": 0.1781153279100538,
                                "percent_change_7d": 0.640773402956385,
                                "percent_change_30d": 0.9122380465730993,
                                "market_cap": 0.48390522151163107,
                                "market_cap_dominance": 4623,
                                "fully_diluted_market_cap": 0.31974987519224274,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.462455707380915,
                                "volume_24h": 0.8999713450982219,
                                "volume_change_24h": 0.9170050000673493,
                                "percent_change_1h": 0.4276960351729284,
                                "percent_change_24h": 0.1781153279100538,
                                "percent_change_7d": 0.640773402956385,
                                "percent_change_30d": 0.9122380465730993,
                                "market_cap": 0.48390522151163107,
                                "market_cap_dominance": 4623,
                                "fully_diluted_market_cap": 0.31974987519224274,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.462455707380915,
                                "volume_24h": 0.8999713450982219,
                                "volume_change_24h": 0.9170050000673493,
                                "percent_change_1h": 0.4276960351729284,
                                "percent_change_24h": 0.1781153279100538,
                                "percent_change_7d": 0.640773402956385,
                                "percent_change_30d": 0.9122380465730993,
                                "market_cap": 0.48390522151163107,
                                "market_cap_dominance": 4623,
                                "fully_diluted_market_cap": 0.31974987519224274,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.462455707380915,
                                "volume_24h": 0.8999713450982219,
                                "volume_change_24h": 0.9170050000673493,
                                "percent_change_1h": 0.4276960351729284,
                                "percent_change_24h": 0.1781153279100538,
                                "percent_change_7d": 0.640773402956385,
                                "percent_change_30d": 0.9122380465730993,
                                "market_cap": 0.48390522151163107,
                                "market_cap_dominance": 4623,
                                "fully_diluted_market_cap": 0.31974987519224274,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.462455707380915,
                                "volume_24h": 0.8999713450982219,
                                "volume_change_24h": 0.9170050000673493,
                                "percent_change_1h": 0.4276960351729284,
                                "percent_change_24h": 0.1781153279100538,
                                "percent_change_7d": 0.640773402956385,
                                "percent_change_30d": 0.9122380465730993,
                                "market_cap": 0.48390522151163107,
                                "market_cap_dominance": 4623,
                                "fully_diluted_market_cap": 0.31974987519224274,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.462455707380915,
                                "volume_24h": 0.8999713450982219,
                                "volume_change_24h": 0.9170050000673493,
                                "percent_change_1h": 0.4276960351729284,
                                "percent_change_24h": 0.1781153279100538,
                                "percent_change_7d": 0.640773402956385,
                                "percent_change_30d": 0.9122380465730993,
                                "market_cap": 0.48390522151163107,
                                "market_cap_dominance": 4623,
                                "fully_diluted_market_cap": 0.31974987519224274,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 9418,
                        "name": "m5n3kzzzty",
                        "symbol": "BUSD",
                        "slug": "lkxmdjezahg",
                        "is_active": 568,
                        "is_fiat": null,
                        "circulating_supply": 9092,
                        "total_supply": 6567,
                        "max_supply": 7651,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 8570,
                        "cmc_rank": 8231,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "nnqjc1ydgyh",
                            "w7zmpq7zbw",
                            "cy4dctoj43p",
                            "ixcneewzmt",
                            "8jaaqy84v2j",
                            "dbaekhb41ji",
                            "nafyxksezr",
                            "e3swlejlz9v",
                            "nshbtpdc7oe",
                            "l638u9g9e0r"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.5890726639960544,
                                "volume_24h": 0.3164732834563839,
                                "volume_change_24h": 0.34921558140059417,
                                "percent_change_1h": 0.9253067842268368,
                                "percent_change_24h": 0.9280226640774509,
                                "percent_change_7d": 0.7191238074637776,
                                "percent_change_30d": 0.09732631471855546,
                                "market_cap": 0.11970207017751666,
                                "market_cap_dominance": 6741,
                                "fully_diluted_market_cap": 0.8356000668675692,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.5890726639960544,
                                "volume_24h": 0.3164732834563839,
                                "volume_change_24h": 0.34921558140059417,
                                "percent_change_1h": 0.9253067842268368,
                                "percent_change_24h": 0.9280226640774509,
                                "percent_change_7d": 0.7191238074637776,
                                "percent_change_30d": 0.09732631471855546,
                                "market_cap": 0.11970207017751666,
                                "market_cap_dominance": 6741,
                                "fully_diluted_market_cap": 0.8356000668675692,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.5890726639960544,
                                "volume_24h": 0.3164732834563839,
                                "volume_change_24h": 0.34921558140059417,
                                "percent_change_1h": 0.9253067842268368,
                                "percent_change_24h": 0.9280226640774509,
                                "percent_change_7d": 0.7191238074637776,
                                "percent_change_30d": 0.09732631471855546,
                                "market_cap": 0.11970207017751666,
                                "market_cap_dominance": 6741,
                                "fully_diluted_market_cap": 0.8356000668675692,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.5890726639960544,
                                "volume_24h": 0.3164732834563839,
                                "volume_change_24h": 0.34921558140059417,
                                "percent_change_1h": 0.9253067842268368,
                                "percent_change_24h": 0.9280226640774509,
                                "percent_change_7d": 0.7191238074637776,
                                "percent_change_30d": 0.09732631471855546,
                                "market_cap": 0.11970207017751666,
                                "market_cap_dominance": 6741,
                                "fully_diluted_market_cap": 0.8356000668675692,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.5890726639960544,
                                "volume_24h": 0.3164732834563839,
                                "volume_change_24h": 0.34921558140059417,
                                "percent_change_1h": 0.9253067842268368,
                                "percent_change_24h": 0.9280226640774509,
                                "percent_change_7d": 0.7191238074637776,
                                "percent_change_30d": 0.09732631471855546,
                                "market_cap": 0.11970207017751666,
                                "market_cap_dominance": 6741,
                                "fully_diluted_market_cap": 0.8356000668675692,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.5890726639960544,
                                "volume_24h": 0.3164732834563839,
                                "volume_change_24h": 0.34921558140059417,
                                "percent_change_1h": 0.9253067842268368,
                                "percent_change_24h": 0.9280226640774509,
                                "percent_change_7d": 0.7191238074637776,
                                "percent_change_30d": 0.09732631471855546,
                                "market_cap": 0.11970207017751666,
                                "market_cap_dominance": 6741,
                                "fully_diluted_market_cap": 0.8356000668675692,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.5890726639960544,
                                "volume_24h": 0.3164732834563839,
                                "volume_change_24h": 0.34921558140059417,
                                "percent_change_1h": 0.9253067842268368,
                                "percent_change_24h": 0.9280226640774509,
                                "percent_change_7d": 0.7191238074637776,
                                "percent_change_30d": 0.09732631471855546,
                                "market_cap": 0.11970207017751666,
                                "market_cap_dominance": 6741,
                                "fully_diluted_market_cap": 0.8356000668675692,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 5047,
                        "name": "tnhlvtgf0m",
                        "symbol": "BUSD",
                        "slug": "c8hebvj6m3b",
                        "is_active": 784,
                        "is_fiat": null,
                        "circulating_supply": 7406,
                        "total_supply": 1547,
                        "max_supply": 4309,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 2404,
                        "cmc_rank": 8732,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "oc9nj020y0d",
                            "be7o8xgq826",
                            "mr7aq3reszo",
                            "z6udsga1zo",
                            "314x6tkczv5",
                            "cqn4r33c3hr",
                            "k1dczzps9lh",
                            "ydwubelv3co",
                            "uv8cug1iekf",
                            "s3zj8cvjlom"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.7872937721744593,
                                "volume_24h": 0.7861080912014442,
                                "volume_change_24h": 0.8782292789586956,
                                "percent_change_1h": 0.8318766341981974,
                                "percent_change_24h": 0.6884005684939936,
                                "percent_change_7d": 0.16314021360702302,
                                "percent_change_30d": 0.09519451933451517,
                                "market_cap": 0.19015812929689924,
                                "market_cap_dominance": 8770,
                                "fully_diluted_market_cap": 0.7298964760199695,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.7872937721744593,
                                "volume_24h": 0.7861080912014442,
                                "volume_change_24h": 0.8782292789586956,
                                "percent_change_1h": 0.8318766341981974,
                                "percent_change_24h": 0.6884005684939936,
                                "percent_change_7d": 0.16314021360702302,
                                "percent_change_30d": 0.09519451933451517,
                                "market_cap": 0.19015812929689924,
                                "market_cap_dominance": 8770,
                                "fully_diluted_market_cap": 0.7298964760199695,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.7872937721744593,
                                "volume_24h": 0.7861080912014442,
                                "volume_change_24h": 0.8782292789586956,
                                "percent_change_1h": 0.8318766341981974,
                                "percent_change_24h": 0.6884005684939936,
                                "percent_change_7d": 0.16314021360702302,
                                "percent_change_30d": 0.09519451933451517,
                                "market_cap": 0.19015812929689924,
                                "market_cap_dominance": 8770,
                                "fully_diluted_market_cap": 0.7298964760199695,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.7872937721744593,
                                "volume_24h": 0.7861080912014442,
                                "volume_change_24h": 0.8782292789586956,
                                "percent_change_1h": 0.8318766341981974,
                                "percent_change_24h": 0.6884005684939936,
                                "percent_change_7d": 0.16314021360702302,
                                "percent_change_30d": 0.09519451933451517,
                                "market_cap": 0.19015812929689924,
                                "market_cap_dominance": 8770,
                                "fully_diluted_market_cap": 0.7298964760199695,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.7872937721744593,
                                "volume_24h": 0.7861080912014442,
                                "volume_change_24h": 0.8782292789586956,
                                "percent_change_1h": 0.8318766341981974,
                                "percent_change_24h": 0.6884005684939936,
                                "percent_change_7d": 0.16314021360702302,
                                "percent_change_30d": 0.09519451933451517,
                                "market_cap": 0.19015812929689924,
                                "market_cap_dominance": 8770,
                                "fully_diluted_market_cap": 0.7298964760199695,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.7872937721744593,
                                "volume_24h": 0.7861080912014442,
                                "volume_change_24h": 0.8782292789586956,
                                "percent_change_1h": 0.8318766341981974,
                                "percent_change_24h": 0.6884005684939936,
                                "percent_change_7d": 0.16314021360702302,
                                "percent_change_30d": 0.09519451933451517,
                                "market_cap": 0.19015812929689924,
                                "market_cap_dominance": 8770,
                                "fully_diluted_market_cap": 0.7298964760199695,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.7872937721744593,
                                "volume_24h": 0.7861080912014442,
                                "volume_change_24h": 0.8782292789586956,
                                "percent_change_1h": 0.8318766341981974,
                                "percent_change_24h": 0.6884005684939936,
                                "percent_change_7d": 0.16314021360702302,
                                "percent_change_30d": 0.09519451933451517,
                                "market_cap": 0.19015812929689924,
                                "market_cap_dominance": 8770,
                                "fully_diluted_market_cap": 0.7298964760199695,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    }
                ],
                "DAI": [
                    {
                        "id": 281,
                        "name": "asgt7zelunc",
                        "symbol": "DAI",
                        "slug": "138o632b475j",
                        "is_active": 6036,
                        "is_fiat": null,
                        "circulating_supply": 5155,
                        "total_supply": 8911,
                        "max_supply": 3720,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 3409,
                        "cmc_rank": 4252,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "snxb6k675fs",
                            "wi6gxnuz3rr",
                            "ped42kdljvl",
                            "zs497qbgxmi",
                            "y2vjpcpez9",
                            "1vzq6qybmkz",
                            "3f0cdy2uwxu",
                            "47r1fbuqh6a",
                            "61tg86nda4k",
                            "7dtxz4mogft"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.8276852129042,
                                "volume_24h": 0.6865800957355541,
                                "volume_change_24h": 0.5418367342016015,
                                "percent_change_1h": 0.7372612477252916,
                                "percent_change_24h": 0.024079106811765616,
                                "percent_change_7d": 0.9290887523961024,
                                "percent_change_30d": 0.28196211338957,
                                "market_cap": 0.9126440642088596,
                                "market_cap_dominance": 17,
                                "fully_diluted_market_cap": 0.5696048103847728,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.8276852129042,
                                "volume_24h": 0.6865800957355541,
                                "volume_change_24h": 0.5418367342016015,
                                "percent_change_1h": 0.7372612477252916,
                                "percent_change_24h": 0.024079106811765616,
                                "percent_change_7d": 0.9290887523961024,
                                "percent_change_30d": 0.28196211338957,
                                "market_cap": 0.9126440642088596,
                                "market_cap_dominance": 17,
                                "fully_diluted_market_cap": 0.5696048103847728,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.8276852129042,
                                "volume_24h": 0.6865800957355541,
                                "volume_change_24h": 0.5418367342016015,
                                "percent_change_1h": 0.7372612477252916,
                                "percent_change_24h": 0.024079106811765616,
                                "percent_change_7d": 0.9290887523961024,
                                "percent_change_30d": 0.28196211338957,
                                "market_cap": 0.9126440642088596,
                                "market_cap_dominance": 17,
                                "fully_diluted_market_cap": 0.5696048103847728,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.8276852129042,
                                "volume_24h": 0.6865800957355541,
                                "volume_change_24h": 0.5418367342016015,
                                "percent_change_1h": 0.7372612477252916,
                                "percent_change_24h": 0.024079106811765616,
                                "percent_change_7d": 0.9290887523961024,
                                "percent_change_30d": 0.28196211338957,
                                "market_cap": 0.9126440642088596,
                                "market_cap_dominance": 17,
                                "fully_diluted_market_cap": 0.5696048103847728,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.8276852129042,
                                "volume_24h": 0.6865800957355541,
                                "volume_change_24h": 0.5418367342016015,
                                "percent_change_1h": 0.7372612477252916,
                                "percent_change_24h": 0.024079106811765616,
                                "percent_change_7d": 0.9290887523961024,
                                "percent_change_30d": 0.28196211338957,
                                "market_cap": 0.9126440642088596,
                                "market_cap_dominance": 17,
                                "fully_diluted_market_cap": 0.5696048103847728,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.8276852129042,
                                "volume_24h": 0.6865800957355541,
                                "volume_change_24h": 0.5418367342016015,
                                "percent_change_1h": 0.7372612477252916,
                                "percent_change_24h": 0.024079106811765616,
                                "percent_change_7d": 0.9290887523961024,
                                "percent_change_30d": 0.28196211338957,
                                "market_cap": 0.9126440642088596,
                                "market_cap_dominance": 17,
                                "fully_diluted_market_cap": 0.5696048103847728,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.8276852129042,
                                "volume_24h": 0.6865800957355541,
                                "volume_change_24h": 0.5418367342016015,
                                "percent_change_1h": 0.7372612477252916,
                                "percent_change_24h": 0.024079106811765616,
                                "percent_change_7d": 0.9290887523961024,
                                "percent_change_30d": 0.28196211338957,
                                "market_cap": 0.9126440642088596,
                                "market_cap_dominance": 17,
                                "fully_diluted_market_cap": 0.5696048103847728,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 2184,
                        "name": "gbu986j3ys",
                        "symbol": "DAI",
                        "slug": "y518ghviphq",
                        "is_active": 2795,
                        "is_fiat": null,
                        "circulating_supply": 4538,
                        "total_supply": 8482,
                        "max_supply": 1531,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 5624,
                        "cmc_rank": 3272,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "2fseomudpmo",
                            "20zbc6pkjl6",
                            "vxt1pa7vss",
                            "3d3j7i3irpq",
                            "y40emgnhmjm",
                            "58kbdojxbir",
                            "5sfx31samj",
                            "xa6akxyb0ae",
                            "o44junve65",
                            "3ktx6udwvck"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.9478297534757152,
                                "volume_24h": 0.13929734029585794,
                                "volume_change_24h": 0.8940325033968146,
                                "percent_change_1h": 0.04553315642944167,
                                "percent_change_24h": 0.3352093373676952,
                                "percent_change_7d": 0.6387811246576507,
                                "percent_change_30d": 0.23594989819352064,
                                "market_cap": 0.3299478048414022,
                                "market_cap_dominance": 2975,
                                "fully_diluted_market_cap": 0.11045110415820081,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.9478297534757152,
                                "volume_24h": 0.13929734029585794,
                                "volume_change_24h": 0.8940325033968146,
                                "percent_change_1h": 0.04553315642944167,
                                "percent_change_24h": 0.3352093373676952,
                                "percent_change_7d": 0.6387811246576507,
                                "percent_change_30d": 0.23594989819352064,
                                "market_cap": 0.3299478048414022,
                                "market_cap_dominance": 2975,
                                "fully_diluted_market_cap": 0.11045110415820081,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.9478297534757152,
                                "volume_24h": 0.13929734029585794,
                                "volume_change_24h": 0.8940325033968146,
                                "percent_change_1h": 0.04553315642944167,
                                "percent_change_24h": 0.3352093373676952,
                                "percent_change_7d": 0.6387811246576507,
                                "percent_change_30d": 0.23594989819352064,
                                "market_cap": 0.3299478048414022,
                                "market_cap_dominance": 2975,
                                "fully_diluted_market_cap": 0.11045110415820081,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.9478297534757152,
                                "volume_24h": 0.13929734029585794,
                                "volume_change_24h": 0.8940325033968146,
                                "percent_change_1h": 0.04553315642944167,
                                "percent_change_24h": 0.3352093373676952,
                                "percent_change_7d": 0.6387811246576507,
                                "percent_change_30d": 0.23594989819352064,
                                "market_cap": 0.3299478048414022,
                                "market_cap_dominance": 2975,
                                "fully_diluted_market_cap": 0.11045110415820081,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.9478297534757152,
                                "volume_24h": 0.13929734029585794,
                                "volume_change_24h": 0.8940325033968146,
                                "percent_change_1h": 0.04553315642944167,
                                "percent_change_24h": 0.3352093373676952,
                                "percent_change_7d": 0.6387811246576507,
                                "percent_change_30d": 0.23594989819352064,
                                "market_cap": 0.3299478048414022,
                                "market_cap_dominance": 2975,
                                "fully_diluted_market_cap": 0.11045110415820081,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.9478297534757152,
                                "volume_24h": 0.13929734029585794,
                                "volume_change_24h": 0.8940325033968146,
                                "percent_change_1h": 0.04553315642944167,
                                "percent_change_24h": 0.3352093373676952,
                                "percent_change_7d": 0.6387811246576507,
                                "percent_change_30d": 0.23594989819352064,
                                "market_cap": 0.3299478048414022,
                                "market_cap_dominance": 2975,
                                "fully_diluted_market_cap": 0.11045110415820081,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.9478297534757152,
                                "volume_24h": 0.13929734029585794,
                                "volume_change_24h": 0.8940325033968146,
                                "percent_change_1h": 0.04553315642944167,
                                "percent_change_24h": 0.3352093373676952,
                                "percent_change_7d": 0.6387811246576507,
                                "percent_change_30d": 0.23594989819352064,
                                "market_cap": 0.3299478048414022,
                                "market_cap_dominance": 2975,
                                "fully_diluted_market_cap": 0.11045110415820081,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 8845,
                        "name": "32s6bgn15in",
                        "symbol": "DAI",
                        "slug": "cvvia8hsmf",
                        "is_active": 1790,
                        "is_fiat": null,
                        "circulating_supply": 2793,
                        "total_supply": 295,
                        "max_supply": 8251,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 30,
                        "cmc_rank": 4822,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "27m99r5pzuq",
                            "efzowf70ezr",
                            "7939pq7tou8",
                            "75uhkzuwhjs",
                            "3n6o6crjyi4",
                            "mkwgy8f1z28",
                            "oeivzb5k5j",
                            "by43kvks2zt",
                            "uexxxnr8kjg",
                            "5qsj03n90wu"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.4827442816542795,
                                "volume_24h": 0.695727453260063,
                                "volume_change_24h": 0.07906792950916142,
                                "percent_change_1h": 0.5331040836739134,
                                "percent_change_24h": 0.9114205190396449,
                                "percent_change_7d": 0.9461671798843214,
                                "percent_change_30d": 0.6847030763208803,
                                "market_cap": 0.7016479889565304,
                                "market_cap_dominance": 1015,
                                "fully_diluted_market_cap": 0.43650052223352565,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.4827442816542795,
                                "volume_24h": 0.695727453260063,
                                "volume_change_24h": 0.07906792950916142,
                                "percent_change_1h": 0.5331040836739134,
                                "percent_change_24h": 0.9114205190396449,
                                "percent_change_7d": 0.9461671798843214,
                                "percent_change_30d": 0.6847030763208803,
                                "market_cap": 0.7016479889565304,
                                "market_cap_dominance": 1015,
                                "fully_diluted_market_cap": 0.43650052223352565,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.4827442816542795,
                                "volume_24h": 0.695727453260063,
                                "volume_change_24h": 0.07906792950916142,
                                "percent_change_1h": 0.5331040836739134,
                                "percent_change_24h": 0.9114205190396449,
                                "percent_change_7d": 0.9461671798843214,
                                "percent_change_30d": 0.6847030763208803,
                                "market_cap": 0.7016479889565304,
                                "market_cap_dominance": 1015,
                                "fully_diluted_market_cap": 0.43650052223352565,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.4827442816542795,
                                "volume_24h": 0.695727453260063,
                                "volume_change_24h": 0.07906792950916142,
                                "percent_change_1h": 0.5331040836739134,
                                "percent_change_24h": 0.9114205190396449,
                                "percent_change_7d": 0.9461671798843214,
                                "percent_change_30d": 0.6847030763208803,
                                "market_cap": 0.7016479889565304,
                                "market_cap_dominance": 1015,
                                "fully_diluted_market_cap": 0.43650052223352565,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.4827442816542795,
                                "volume_24h": 0.695727453260063,
                                "volume_change_24h": 0.07906792950916142,
                                "percent_change_1h": 0.5331040836739134,
                                "percent_change_24h": 0.9114205190396449,
                                "percent_change_7d": 0.9461671798843214,
                                "percent_change_30d": 0.6847030763208803,
                                "market_cap": 0.7016479889565304,
                                "market_cap_dominance": 1015,
                                "fully_diluted_market_cap": 0.43650052223352565,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.4827442816542795,
                                "volume_24h": 0.695727453260063,
                                "volume_change_24h": 0.07906792950916142,
                                "percent_change_1h": 0.5331040836739134,
                                "percent_change_24h": 0.9114205190396449,
                                "percent_change_7d": 0.9461671798843214,
                                "percent_change_30d": 0.6847030763208803,
                                "market_cap": 0.7016479889565304,
                                "market_cap_dominance": 1015,
                                "fully_diluted_market_cap": 0.43650052223352565,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.4827442816542795,
                                "volume_24h": 0.695727453260063,
                                "volume_change_24h": 0.07906792950916142,
                                "percent_change_1h": 0.5331040836739134,
                                "percent_change_24h": 0.9114205190396449,
                                "percent_change_7d": 0.9461671798843214,
                                "percent_change_30d": 0.6847030763208803,
                                "market_cap": 0.7016479889565304,
                                "market_cap_dominance": 1015,
                                "fully_diluted_market_cap": 0.43650052223352565,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    }
                ],
                "DOGE": [
                    {
                        "id": 8715,
                        "name": "lci0yxcajq",
                        "symbol": "DOGE",
                        "slug": "dy699z1njms",
                        "is_active": 7033,
                        "is_fiat": null,
                        "circulating_supply": 9764,
                        "total_supply": 3878,
                        "max_supply": 1280,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 2006,
                        "cmc_rank": 507,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "ea2ubb8kryh",
                            "hnolm241sbl",
                            "p1tdccamk6i",
                            "k68j0f5p43",
                            "qnu9iz0hml",
                            "d7bzp08w1xo",
                            "h1gvuexlrui",
                            "7u020wak7ax",
                            "u3lf8o84nzg",
                            "utnsva747id"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.7062756689053955,
                                "volume_24h": 0.7167852933058425,
                                "volume_change_24h": 0.30220035413418356,
                                "percent_change_1h": 0.339262089218447,
                                "percent_change_24h": 0.08034814106461874,
                                "percent_change_7d": 0.20923059799008947,
                                "percent_change_30d": 0.9549916784668953,
                                "market_cap": 0.3456379890297734,
                                "market_cap_dominance": 555,
                                "fully_diluted_market_cap": 0.35314763326564,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.7062756689053955,
                                "volume_24h": 0.7167852933058425,
                                "volume_change_24h": 0.30220035413418356,
                                "percent_change_1h": 0.339262089218447,
                                "percent_change_24h": 0.08034814106461874,
                                "percent_change_7d": 0.20923059799008947,
                                "percent_change_30d": 0.9549916784668953,
                                "market_cap": 0.3456379890297734,
                                "market_cap_dominance": 555,
                                "fully_diluted_market_cap": 0.35314763326564,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.7062756689053955,
                                "volume_24h": 0.7167852933058425,
                                "volume_change_24h": 0.30220035413418356,
                                "percent_change_1h": 0.339262089218447,
                                "percent_change_24h": 0.08034814106461874,
                                "percent_change_7d": 0.20923059799008947,
                                "percent_change_30d": 0.9549916784668953,
                                "market_cap": 0.3456379890297734,
                                "market_cap_dominance": 555,
                                "fully_diluted_market_cap": 0.35314763326564,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.7062756689053955,
                                "volume_24h": 0.7167852933058425,
                                "volume_change_24h": 0.30220035413418356,
                                "percent_change_1h": 0.339262089218447,
                                "percent_change_24h": 0.08034814106461874,
                                "percent_change_7d": 0.20923059799008947,
                                "percent_change_30d": 0.9549916784668953,
                                "market_cap": 0.3456379890297734,
                                "market_cap_dominance": 555,
                                "fully_diluted_market_cap": 0.35314763326564,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.7062756689053955,
                                "volume_24h": 0.7167852933058425,
                                "volume_change_24h": 0.30220035413418356,
                                "percent_change_1h": 0.339262089218447,
                                "percent_change_24h": 0.08034814106461874,
                                "percent_change_7d": 0.20923059799008947,
                                "percent_change_30d": 0.9549916784668953,
                                "market_cap": 0.3456379890297734,
                                "market_cap_dominance": 555,
                                "fully_diluted_market_cap": 0.35314763326564,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.7062756689053955,
                                "volume_24h": 0.7167852933058425,
                                "volume_change_24h": 0.30220035413418356,
                                "percent_change_1h": 0.339262089218447,
                                "percent_change_24h": 0.08034814106461874,
                                "percent_change_7d": 0.20923059799008947,
                                "percent_change_30d": 0.9549916784668953,
                                "market_cap": 0.3456379890297734,
                                "market_cap_dominance": 555,
                                "fully_diluted_market_cap": 0.35314763326564,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.7062756689053955,
                                "volume_24h": 0.7167852933058425,
                                "volume_change_24h": 0.30220035413418356,
                                "percent_change_1h": 0.339262089218447,
                                "percent_change_24h": 0.08034814106461874,
                                "percent_change_7d": 0.20923059799008947,
                                "percent_change_30d": 0.9549916784668953,
                                "market_cap": 0.3456379890297734,
                                "market_cap_dominance": 555,
                                "fully_diluted_market_cap": 0.35314763326564,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 5501,
                        "name": "8aiablhzcvt",
                        "symbol": "DOGE",
                        "slug": "eh41h339o5",
                        "is_active": 582,
                        "is_fiat": null,
                        "circulating_supply": 5075,
                        "total_supply": 5483,
                        "max_supply": 4715,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 8961,
                        "cmc_rank": 8374,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "dk3sjj9ar9l",
                            "9xdo6hgdxk",
                            "jdxh4ch813d",
                            "21376qbvizai",
                            "47vsbxx8122",
                            "a542rk2regd",
                            "ye7uv61hb6",
                            "kz041ihzru8",
                            "hyyiwh9jlo",
                            "81aofse4o79"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.2078662458094982,
                                "volume_24h": 0.8977798120018048,
                                "volume_change_24h": 0.940180435917904,
                                "percent_change_1h": 0.7436246476816724,
                                "percent_change_24h": 0.08484284360361682,
                                "percent_change_7d": 0.02859874661231232,
                                "percent_change_30d": 0.07892144046177352,
                                "market_cap": 0.9574391723085622,
                                "market_cap_dominance": 3590,
                                "fully_diluted_market_cap": 0.20722766031439388,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.2078662458094982,
                                "volume_24h": 0.8977798120018048,
                                "volume_change_24h": 0.940180435917904,
                                "percent_change_1h": 0.7436246476816724,
                                "percent_change_24h": 0.08484284360361682,
                                "percent_change_7d": 0.02859874661231232,
                                "percent_change_30d": 0.07892144046177352,
                                "market_cap": 0.9574391723085622,
                                "market_cap_dominance": 3590,
                                "fully_diluted_market_cap": 0.20722766031439388,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.2078662458094982,
                                "volume_24h": 0.8977798120018048,
                                "volume_change_24h": 0.940180435917904,
                                "percent_change_1h": 0.7436246476816724,
                                "percent_change_24h": 0.08484284360361682,
                                "percent_change_7d": 0.02859874661231232,
                                "percent_change_30d": 0.07892144046177352,
                                "market_cap": 0.9574391723085622,
                                "market_cap_dominance": 3590,
                                "fully_diluted_market_cap": 0.20722766031439388,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.2078662458094982,
                                "volume_24h": 0.8977798120018048,
                                "volume_change_24h": 0.940180435917904,
                                "percent_change_1h": 0.7436246476816724,
                                "percent_change_24h": 0.08484284360361682,
                                "percent_change_7d": 0.02859874661231232,
                                "percent_change_30d": 0.07892144046177352,
                                "market_cap": 0.9574391723085622,
                                "market_cap_dominance": 3590,
                                "fully_diluted_market_cap": 0.20722766031439388,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.2078662458094982,
                                "volume_24h": 0.8977798120018048,
                                "volume_change_24h": 0.940180435917904,
                                "percent_change_1h": 0.7436246476816724,
                                "percent_change_24h": 0.08484284360361682,
                                "percent_change_7d": 0.02859874661231232,
                                "percent_change_30d": 0.07892144046177352,
                                "market_cap": 0.9574391723085622,
                                "market_cap_dominance": 3590,
                                "fully_diluted_market_cap": 0.20722766031439388,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.2078662458094982,
                                "volume_24h": 0.8977798120018048,
                                "volume_change_24h": 0.940180435917904,
                                "percent_change_1h": 0.7436246476816724,
                                "percent_change_24h": 0.08484284360361682,
                                "percent_change_7d": 0.02859874661231232,
                                "percent_change_30d": 0.07892144046177352,
                                "market_cap": 0.9574391723085622,
                                "market_cap_dominance": 3590,
                                "fully_diluted_market_cap": 0.20722766031439388,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.2078662458094982,
                                "volume_24h": 0.8977798120018048,
                                "volume_change_24h": 0.940180435917904,
                                "percent_change_1h": 0.7436246476816724,
                                "percent_change_24h": 0.08484284360361682,
                                "percent_change_7d": 0.02859874661231232,
                                "percent_change_30d": 0.07892144046177352,
                                "market_cap": 0.9574391723085622,
                                "market_cap_dominance": 3590,
                                "fully_diluted_market_cap": 0.20722766031439388,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 2062,
                        "name": "ywk9qz0fcs",
                        "symbol": "DOGE",
                        "slug": "3yplmks5z9e",
                        "is_active": 7659,
                        "is_fiat": null,
                        "circulating_supply": 9753,
                        "total_supply": 5885,
                        "max_supply": 403,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 2580,
                        "cmc_rank": 4421,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "z704rta2t28",
                            "yb9nbqawe9",
                            "f84p3eeb4n8",
                            "1ixom5rbfmy",
                            "zcf3nkud9lr",
                            "el2h0wmsmna",
                            "q9hzw6gllt",
                            "fqkox1pwm4b",
                            "fqqlkbagsi6",
                            "ft33jc34q45"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.4831449260033944,
                                "volume_24h": 0.3356714687116338,
                                "volume_change_24h": 0.25603430708465846,
                                "percent_change_1h": 0.033714903875807556,
                                "percent_change_24h": 0.04038623137621,
                                "percent_change_7d": 0.39870624472467164,
                                "percent_change_30d": 0.7767302592121803,
                                "market_cap": 0.18045396309069028,
                                "market_cap_dominance": 5343,
                                "fully_diluted_market_cap": 0.380560610255664,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.4831449260033944,
                                "volume_24h": 0.3356714687116338,
                                "volume_change_24h": 0.25603430708465846,
                                "percent_change_1h": 0.033714903875807556,
                                "percent_change_24h": 0.04038623137621,
                                "percent_change_7d": 0.39870624472467164,
                                "percent_change_30d": 0.7767302592121803,
                                "market_cap": 0.18045396309069028,
                                "market_cap_dominance": 5343,
                                "fully_diluted_market_cap": 0.380560610255664,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.4831449260033944,
                                "volume_24h": 0.3356714687116338,
                                "volume_change_24h": 0.25603430708465846,
                                "percent_change_1h": 0.033714903875807556,
                                "percent_change_24h": 0.04038623137621,
                                "percent_change_7d": 0.39870624472467164,
                                "percent_change_30d": 0.7767302592121803,
                                "market_cap": 0.18045396309069028,
                                "market_cap_dominance": 5343,
                                "fully_diluted_market_cap": 0.380560610255664,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.4831449260033944,
                                "volume_24h": 0.3356714687116338,
                                "volume_change_24h": 0.25603430708465846,
                                "percent_change_1h": 0.033714903875807556,
                                "percent_change_24h": 0.04038623137621,
                                "percent_change_7d": 0.39870624472467164,
                                "percent_change_30d": 0.7767302592121803,
                                "market_cap": 0.18045396309069028,
                                "market_cap_dominance": 5343,
                                "fully_diluted_market_cap": 0.380560610255664,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.4831449260033944,
                                "volume_24h": 0.3356714687116338,
                                "volume_change_24h": 0.25603430708465846,
                                "percent_change_1h": 0.033714903875807556,
                                "percent_change_24h": 0.04038623137621,
                                "percent_change_7d": 0.39870624472467164,
                                "percent_change_30d": 0.7767302592121803,
                                "market_cap": 0.18045396309069028,
                                "market_cap_dominance": 5343,
                                "fully_diluted_market_cap": 0.380560610255664,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.4831449260033944,
                                "volume_24h": 0.3356714687116338,
                                "volume_change_24h": 0.25603430708465846,
                                "percent_change_1h": 0.033714903875807556,
                                "percent_change_24h": 0.04038623137621,
                                "percent_change_7d": 0.39870624472467164,
                                "percent_change_30d": 0.7767302592121803,
                                "market_cap": 0.18045396309069028,
                                "market_cap_dominance": 5343,
                                "fully_diluted_market_cap": 0.380560610255664,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.4831449260033944,
                                "volume_24h": 0.3356714687116338,
                                "volume_change_24h": 0.25603430708465846,
                                "percent_change_1h": 0.033714903875807556,
                                "percent_change_24h": 0.04038623137621,
                                "percent_change_7d": 0.39870624472467164,
                                "percent_change_30d": 0.7767302592121803,
                                "market_cap": 0.18045396309069028,
                                "market_cap_dominance": 5343,
                                "fully_diluted_market_cap": 0.380560610255664,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    }
                ],
                "ETH": [
                    {
                        "id": 1436,
                        "name": "hdwsylgnv87",
                        "symbol": "ETH",
                        "slug": "kjvfrhr2kae",
                        "is_active": 2766,
                        "is_fiat": null,
                        "circulating_supply": 1616,
                        "total_supply": 2254,
                        "max_supply": 6394,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 4805,
                        "cmc_rank": 2477,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "lt9rttcln9d",
                            "sn8322mxq5",
                            "0moqmmy3g9ko",
                            "3zduydzkpbf",
                            "5qy450lpgsq",
                            "ex5vnsfolk",
                            "aag7wnwh7f8",
                            "3uzt0l5paxt",
                            "kv3tv981mac",
                            "7vzmuxh5wty"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.7091162324903235,
                                "volume_24h": 0.9250108457011199,
                                "volume_change_24h": 0.5636738282808549,
                                "percent_change_1h": 0.9905778770768321,
                                "percent_change_24h": 0.8286732109149084,
                                "percent_change_7d": 0.9972615050973928,
                                "percent_change_30d": 0.21110834059855255,
                                "market_cap": 0.45304545515154104,
                                "market_cap_dominance": 8873,
                                "fully_diluted_market_cap": 0.1645711338854532,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.7091162324903235,
                                "volume_24h": 0.9250108457011199,
                                "volume_change_24h": 0.5636738282808549,
                                "percent_change_1h": 0.9905778770768321,
                                "percent_change_24h": 0.8286732109149084,
                                "percent_change_7d": 0.9972615050973928,
                                "percent_change_30d": 0.21110834059855255,
                                "market_cap": 0.45304545515154104,
                                "market_cap_dominance": 8873,
                                "fully_diluted_market_cap": 0.1645711338854532,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.7091162324903235,
                                "volume_24h": 0.9250108457011199,
                                "volume_change_24h": 0.5636738282808549,
                                "percent_change_1h": 0.9905778770768321,
                                "percent_change_24h": 0.8286732109149084,
                                "percent_change_7d": 0.9972615050973928,
                                "percent_change_30d": 0.21110834059855255,
                                "market_cap": 0.45304545515154104,
                                "market_cap_dominance": 8873,
                                "fully_diluted_market_cap": 0.1645711338854532,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.7091162324903235,
                                "volume_24h": 0.9250108457011199,
                                "volume_change_24h": 0.5636738282808549,
                                "percent_change_1h": 0.9905778770768321,
                                "percent_change_24h": 0.8286732109149084,
                                "percent_change_7d": 0.9972615050973928,
                                "percent_change_30d": 0.21110834059855255,
                                "market_cap": 0.45304545515154104,
                                "market_cap_dominance": 8873,
                                "fully_diluted_market_cap": 0.1645711338854532,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.7091162324903235,
                                "volume_24h": 0.9250108457011199,
                                "volume_change_24h": 0.5636738282808549,
                                "percent_change_1h": 0.9905778770768321,
                                "percent_change_24h": 0.8286732109149084,
                                "percent_change_7d": 0.9972615050973928,
                                "percent_change_30d": 0.21110834059855255,
                                "market_cap": 0.45304545515154104,
                                "market_cap_dominance": 8873,
                                "fully_diluted_market_cap": 0.1645711338854532,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.7091162324903235,
                                "volume_24h": 0.9250108457011199,
                                "volume_change_24h": 0.5636738282808549,
                                "percent_change_1h": 0.9905778770768321,
                                "percent_change_24h": 0.8286732109149084,
                                "percent_change_7d": 0.9972615050973928,
                                "percent_change_30d": 0.21110834059855255,
                                "market_cap": 0.45304545515154104,
                                "market_cap_dominance": 8873,
                                "fully_diluted_market_cap": 0.1645711338854532,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.7091162324903235,
                                "volume_24h": 0.9250108457011199,
                                "volume_change_24h": 0.5636738282808549,
                                "percent_change_1h": 0.9905778770768321,
                                "percent_change_24h": 0.8286732109149084,
                                "percent_change_7d": 0.9972615050973928,
                                "percent_change_30d": 0.21110834059855255,
                                "market_cap": 0.45304545515154104,
                                "market_cap_dominance": 8873,
                                "fully_diluted_market_cap": 0.1645711338854532,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 9660,
                        "name": "xu7nqcmk2g",
                        "symbol": "ETH",
                        "slug": "i6lx1ig50dp",
                        "is_active": 6298,
                        "is_fiat": null,
                        "circulating_supply": 91,
                        "total_supply": 5093,
                        "max_supply": 8186,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 9093,
                        "cmc_rank": 8775,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "vdkupfbjgng",
                            "6ym7jm40lyr",
                            "uzdmf4g5nk",
                            "epdlwsn4oco",
                            "odjjy6vqbzb",
                            "0egvi6eumuvd",
                            "7iaotky4r3m",
                            "mkvzjgb3t7p",
                            "g1ulua42nat",
                            "vah97sesb2d"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.44309793309652457,
                                "volume_24h": 0.6721497792736548,
                                "volume_change_24h": 0.42575951735877227,
                                "percent_change_1h": 0.2806811962332745,
                                "percent_change_24h": 0.7275691709469838,
                                "percent_change_7d": 0.5964200967969333,
                                "percent_change_30d": 0.9616833724429985,
                                "market_cap": 0.873874985220819,
                                "market_cap_dominance": 7286,
                                "fully_diluted_market_cap": 0.268601910205708,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.44309793309652457,
                                "volume_24h": 0.6721497792736548,
                                "volume_change_24h": 0.42575951735877227,
                                "percent_change_1h": 0.2806811962332745,
                                "percent_change_24h": 0.7275691709469838,
                                "percent_change_7d": 0.5964200967969333,
                                "percent_change_30d": 0.9616833724429985,
                                "market_cap": 0.873874985220819,
                                "market_cap_dominance": 7286,
                                "fully_diluted_market_cap": 0.268601910205708,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.44309793309652457,
                                "volume_24h": 0.6721497792736548,
                                "volume_change_24h": 0.42575951735877227,
                                "percent_change_1h": 0.2806811962332745,
                                "percent_change_24h": 0.7275691709469838,
                                "percent_change_7d": 0.5964200967969333,
                                "percent_change_30d": 0.9616833724429985,
                                "market_cap": 0.873874985220819,
                                "market_cap_dominance": 7286,
                                "fully_diluted_market_cap": 0.268601910205708,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.44309793309652457,
                                "volume_24h": 0.6721497792736548,
                                "volume_change_24h": 0.42575951735877227,
                                "percent_change_1h": 0.2806811962332745,
                                "percent_change_24h": 0.7275691709469838,
                                "percent_change_7d": 0.5964200967969333,
                                "percent_change_30d": 0.9616833724429985,
                                "market_cap": 0.873874985220819,
                                "market_cap_dominance": 7286,
                                "fully_diluted_market_cap": 0.268601910205708,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.44309793309652457,
                                "volume_24h": 0.6721497792736548,
                                "volume_change_24h": 0.42575951735877227,
                                "percent_change_1h": 0.2806811962332745,
                                "percent_change_24h": 0.7275691709469838,
                                "percent_change_7d": 0.5964200967969333,
                                "percent_change_30d": 0.9616833724429985,
                                "market_cap": 0.873874985220819,
                                "market_cap_dominance": 7286,
                                "fully_diluted_market_cap": 0.268601910205708,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.44309793309652457,
                                "volume_24h": 0.6721497792736548,
                                "volume_change_24h": 0.42575951735877227,
                                "percent_change_1h": 0.2806811962332745,
                                "percent_change_24h": 0.7275691709469838,
                                "percent_change_7d": 0.5964200967969333,
                                "percent_change_30d": 0.9616833724429985,
                                "market_cap": 0.873874985220819,
                                "market_cap_dominance": 7286,
                                "fully_diluted_market_cap": 0.268601910205708,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.44309793309652457,
                                "volume_24h": 0.6721497792736548,
                                "volume_change_24h": 0.42575951735877227,
                                "percent_change_1h": 0.2806811962332745,
                                "percent_change_24h": 0.7275691709469838,
                                "percent_change_7d": 0.5964200967969333,
                                "percent_change_30d": 0.9616833724429985,
                                "market_cap": 0.873874985220819,
                                "market_cap_dominance": 7286,
                                "fully_diluted_market_cap": 0.268601910205708,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 6844,
                        "name": "l3ec4rlj9u",
                        "symbol": "ETH",
                        "slug": "46lp1y5xm7m",
                        "is_active": 6675,
                        "is_fiat": null,
                        "circulating_supply": 4915,
                        "total_supply": 1580,
                        "max_supply": 1378,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 4085,
                        "cmc_rank": 4201,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "0rm1kehjoa8p",
                            "ih8szqak5cb",
                            "gkhaa629mdm",
                            "un7nfmirfg",
                            "aexftnyd54",
                            "ibm7lep1vy",
                            "o2ycj1bnhge",
                            "8ccpukniqh6",
                            "a51aco45154",
                            "mok6jxv9o"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.32107183122094707,
                                "volume_24h": 0.14462564442570747,
                                "volume_change_24h": 0.6291955514555161,
                                "percent_change_1h": 0.505511763268488,
                                "percent_change_24h": 0.48306028350278774,
                                "percent_change_7d": 0.6159164195053182,
                                "percent_change_30d": 0.9687306964691194,
                                "market_cap": 0.3281951240908505,
                                "market_cap_dominance": 4325,
                                "fully_diluted_market_cap": 0.9928509912424286,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.32107183122094707,
                                "volume_24h": 0.14462564442570747,
                                "volume_change_24h": 0.6291955514555161,
                                "percent_change_1h": 0.505511763268488,
                                "percent_change_24h": 0.48306028350278774,
                                "percent_change_7d": 0.6159164195053182,
                                "percent_change_30d": 0.9687306964691194,
                                "market_cap": 0.3281951240908505,
                                "market_cap_dominance": 4325,
                                "fully_diluted_market_cap": 0.9928509912424286,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.32107183122094707,
                                "volume_24h": 0.14462564442570747,
                                "volume_change_24h": 0.6291955514555161,
                                "percent_change_1h": 0.505511763268488,
                                "percent_change_24h": 0.48306028350278774,
                                "percent_change_7d": 0.6159164195053182,
                                "percent_change_30d": 0.9687306964691194,
                                "market_cap": 0.3281951240908505,
                                "market_cap_dominance": 4325,
                                "fully_diluted_market_cap": 0.9928509912424286,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.32107183122094707,
                                "volume_24h": 0.14462564442570747,
                                "volume_change_24h": 0.6291955514555161,
                                "percent_change_1h": 0.505511763268488,
                                "percent_change_24h": 0.48306028350278774,
                                "percent_change_7d": 0.6159164195053182,
                                "percent_change_30d": 0.9687306964691194,
                                "market_cap": 0.3281951240908505,
                                "market_cap_dominance": 4325,
                                "fully_diluted_market_cap": 0.9928509912424286,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.32107183122094707,
                                "volume_24h": 0.14462564442570747,
                                "volume_change_24h": 0.6291955514555161,
                                "percent_change_1h": 0.505511763268488,
                                "percent_change_24h": 0.48306028350278774,
                                "percent_change_7d": 0.6159164195053182,
                                "percent_change_30d": 0.9687306964691194,
                                "market_cap": 0.3281951240908505,
                                "market_cap_dominance": 4325,
                                "fully_diluted_market_cap": 0.9928509912424286,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.32107183122094707,
                                "volume_24h": 0.14462564442570747,
                                "volume_change_24h": 0.6291955514555161,
                                "percent_change_1h": 0.505511763268488,
                                "percent_change_24h": 0.48306028350278774,
                                "percent_change_7d": 0.6159164195053182,
                                "percent_change_30d": 0.9687306964691194,
                                "market_cap": 0.3281951240908505,
                                "market_cap_dominance": 4325,
                                "fully_diluted_market_cap": 0.9928509912424286,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.32107183122094707,
                                "volume_24h": 0.14462564442570747,
                                "volume_change_24h": 0.6291955514555161,
                                "percent_change_1h": 0.505511763268488,
                                "percent_change_24h": 0.48306028350278774,
                                "percent_change_7d": 0.6159164195053182,
                                "percent_change_30d": 0.9687306964691194,
                                "market_cap": 0.3281951240908505,
                                "market_cap_dominance": 4325,
                                "fully_diluted_market_cap": 0.9928509912424286,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    }
                ],
                "GUSD": [
                    {
                        "id": 1813,
                        "name": "hhdwxcvqvmn",
                        "symbol": "GUSD",
                        "slug": "xu6jw5mraod",
                        "is_active": 7845,
                        "is_fiat": null,
                        "circulating_supply": 1682,
                        "total_supply": 1537,
                        "max_supply": 836,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 6437,
                        "cmc_rank": 3092,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "g5jarmorr9",
                            "2gxznaersin",
                            "j6nyjrosfu",
                            "t506mmczthm",
                            "19n5s23kba1",
                            "jpv83a2rbm",
                            "jt3ws1dqskq",
                            "pcpyoweltpl",
                            "zhy560y07f",
                            "mz1vpjspttd"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.23510210361366402,
                                "volume_24h": 0.3588976583288652,
                                "volume_change_24h": 0.5509400268879674,
                                "percent_change_1h": 0.35537559356338067,
                                "percent_change_24h": 0.9665454777940523,
                                "percent_change_7d": 0.36387824299375127,
                                "percent_change_30d": 0.8982743396145596,
                                "market_cap": 0.1684536430071406,
                                "market_cap_dominance": 2178,
                                "fully_diluted_market_cap": 0.8429883472007527,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.23510210361366402,
                                "volume_24h": 0.3588976583288652,
                                "volume_change_24h": 0.5509400268879674,
                                "percent_change_1h": 0.35537559356338067,
                                "percent_change_24h": 0.9665454777940523,
                                "percent_change_7d": 0.36387824299375127,
                                "percent_change_30d": 0.8982743396145596,
                                "market_cap": 0.1684536430071406,
                                "market_cap_dominance": 2178,
                                "fully_diluted_market_cap": 0.8429883472007527,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.23510210361366402,
                                "volume_24h": 0.3588976583288652,
                                "volume_change_24h": 0.5509400268879674,
                                "percent_change_1h": 0.35537559356338067,
                                "percent_change_24h": 0.9665454777940523,
                                "percent_change_7d": 0.36387824299375127,
                                "percent_change_30d": 0.8982743396145596,
                                "market_cap": 0.1684536430071406,
                                "market_cap_dominance": 2178,
                                "fully_diluted_market_cap": 0.8429883472007527,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.23510210361366402,
                                "volume_24h": 0.3588976583288652,
                                "volume_change_24h": 0.5509400268879674,
                                "percent_change_1h": 0.35537559356338067,
                                "percent_change_24h": 0.9665454777940523,
                                "percent_change_7d": 0.36387824299375127,
                                "percent_change_30d": 0.8982743396145596,
                                "market_cap": 0.1684536430071406,
                                "market_cap_dominance": 2178,
                                "fully_diluted_market_cap": 0.8429883472007527,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.23510210361366402,
                                "volume_24h": 0.3588976583288652,
                                "volume_change_24h": 0.5509400268879674,
                                "percent_change_1h": 0.35537559356338067,
                                "percent_change_24h": 0.9665454777940523,
                                "percent_change_7d": 0.36387824299375127,
                                "percent_change_30d": 0.8982743396145596,
                                "market_cap": 0.1684536430071406,
                                "market_cap_dominance": 2178,
                                "fully_diluted_market_cap": 0.8429883472007527,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.23510210361366402,
                                "volume_24h": 0.3588976583288652,
                                "volume_change_24h": 0.5509400268879674,
                                "percent_change_1h": 0.35537559356338067,
                                "percent_change_24h": 0.9665454777940523,
                                "percent_change_7d": 0.36387824299375127,
                                "percent_change_30d": 0.8982743396145596,
                                "market_cap": 0.1684536430071406,
                                "market_cap_dominance": 2178,
                                "fully_diluted_market_cap": 0.8429883472007527,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.23510210361366402,
                                "volume_24h": 0.3588976583288652,
                                "volume_change_24h": 0.5509400268879674,
                                "percent_change_1h": 0.35537559356338067,
                                "percent_change_24h": 0.9665454777940523,
                                "percent_change_7d": 0.36387824299375127,
                                "percent_change_30d": 0.8982743396145596,
                                "market_cap": 0.1684536430071406,
                                "market_cap_dominance": 2178,
                                "fully_diluted_market_cap": 0.8429883472007527,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 2669,
                        "name": "vwp3z096yyr",
                        "symbol": "GUSD",
                        "slug": "cs9qq4b70jt",
                        "is_active": 6423,
                        "is_fiat": null,
                        "circulating_supply": 4745,
                        "total_supply": 6195,
                        "max_supply": 2994,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 3777,
                        "cmc_rank": 9899,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "7pl9huklp7g",
                            "4uaucab0g54",
                            "9sbgi0r7g18",
                            "qo69hffstpj",
                            "5r4bbdoma0u",
                            "12w3d37266d",
                            "pwir0dmq2wg",
                            "012ox5c40j18",
                            "5kpybo5utfh",
                            "pahezumwsme"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.9465481518709054,
                                "volume_24h": 0.7552142743300159,
                                "volume_change_24h": 0.0840668857566853,
                                "percent_change_1h": 0.9053696631871535,
                                "percent_change_24h": 0.3484438263999605,
                                "percent_change_7d": 0.36110876617763377,
                                "percent_change_30d": 0.6688983060865572,
                                "market_cap": 0.06187724722645438,
                                "market_cap_dominance": 5240,
                                "fully_diluted_market_cap": 0.40828321942463686,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.9465481518709054,
                                "volume_24h": 0.7552142743300159,
                                "volume_change_24h": 0.0840668857566853,
                                "percent_change_1h": 0.9053696631871535,
                                "percent_change_24h": 0.3484438263999605,
                                "percent_change_7d": 0.36110876617763377,
                                "percent_change_30d": 0.6688983060865572,
                                "market_cap": 0.06187724722645438,
                                "market_cap_dominance": 5240,
                                "fully_diluted_market_cap": 0.40828321942463686,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.9465481518709054,
                                "volume_24h": 0.7552142743300159,
                                "volume_change_24h": 0.0840668857566853,
                                "percent_change_1h": 0.9053696631871535,
                                "percent_change_24h": 0.3484438263999605,
                                "percent_change_7d": 0.36110876617763377,
                                "percent_change_30d": 0.6688983060865572,
                                "market_cap": 0.06187724722645438,
                                "market_cap_dominance": 5240,
                                "fully_diluted_market_cap": 0.40828321942463686,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.9465481518709054,
                                "volume_24h": 0.7552142743300159,
                                "volume_change_24h": 0.0840668857566853,
                                "percent_change_1h": 0.9053696631871535,
                                "percent_change_24h": 0.3484438263999605,
                                "percent_change_7d": 0.36110876617763377,
                                "percent_change_30d": 0.6688983060865572,
                                "market_cap": 0.06187724722645438,
                                "market_cap_dominance": 5240,
                                "fully_diluted_market_cap": 0.40828321942463686,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.9465481518709054,
                                "volume_24h": 0.7552142743300159,
                                "volume_change_24h": 0.0840668857566853,
                                "percent_change_1h": 0.9053696631871535,
                                "percent_change_24h": 0.3484438263999605,
                                "percent_change_7d": 0.36110876617763377,
                                "percent_change_30d": 0.6688983060865572,
                                "market_cap": 0.06187724722645438,
                                "market_cap_dominance": 5240,
                                "fully_diluted_market_cap": 0.40828321942463686,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.9465481518709054,
                                "volume_24h": 0.7552142743300159,
                                "volume_change_24h": 0.0840668857566853,
                                "percent_change_1h": 0.9053696631871535,
                                "percent_change_24h": 0.3484438263999605,
                                "percent_change_7d": 0.36110876617763377,
                                "percent_change_30d": 0.6688983060865572,
                                "market_cap": 0.06187724722645438,
                                "market_cap_dominance": 5240,
                                "fully_diluted_market_cap": 0.40828321942463686,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.9465481518709054,
                                "volume_24h": 0.7552142743300159,
                                "volume_change_24h": 0.0840668857566853,
                                "percent_change_1h": 0.9053696631871535,
                                "percent_change_24h": 0.3484438263999605,
                                "percent_change_7d": 0.36110876617763377,
                                "percent_change_30d": 0.6688983060865572,
                                "market_cap": 0.06187724722645438,
                                "market_cap_dominance": 5240,
                                "fully_diluted_market_cap": 0.40828321942463686,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 8058,
                        "name": "375k9g6kvd9",
                        "symbol": "GUSD",
                        "slug": "pmzaevzj9o",
                        "is_active": 3368,
                        "is_fiat": null,
                        "circulating_supply": 2911,
                        "total_supply": 1621,
                        "max_supply": 37,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 1961,
                        "cmc_rank": 9886,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "1jrg9gsxdm2",
                            "6s4n06bgflb",
                            "jayis3q35xb",
                            "s4cu37k513",
                            "11l8sya677z9",
                            "mxi24xksw0n",
                            "be479r5zttf",
                            "gipytrm29lo",
                            "e7lta2xzow",
                            "syoqhxxvtiq"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.11177393253781598,
                                "volume_24h": 0.7399174477906934,
                                "volume_change_24h": 0.47848056049394083,
                                "percent_change_1h": 0.9211019486460588,
                                "percent_change_24h": 0.7928289600067424,
                                "percent_change_7d": 0.9349154003085534,
                                "percent_change_30d": 0.10256269568678333,
                                "market_cap": 0.4493079809812057,
                                "market_cap_dominance": 3276,
                                "fully_diluted_market_cap": 0.5242425980646053,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.11177393253781598,
                                "volume_24h": 0.7399174477906934,
                                "volume_change_24h": 0.47848056049394083,
                                "percent_change_1h": 0.9211019486460588,
                                "percent_change_24h": 0.7928289600067424,
                                "percent_change_7d": 0.9349154003085534,
                                "percent_change_30d": 0.10256269568678333,
                                "market_cap": 0.4493079809812057,
                                "market_cap_dominance": 3276,
                                "fully_diluted_market_cap": 0.5242425980646053,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.11177393253781598,
                                "volume_24h": 0.7399174477906934,
                                "volume_change_24h": 0.47848056049394083,
                                "percent_change_1h": 0.9211019486460588,
                                "percent_change_24h": 0.7928289600067424,
                                "percent_change_7d": 0.9349154003085534,
                                "percent_change_30d": 0.10256269568678333,
                                "market_cap": 0.4493079809812057,
                                "market_cap_dominance": 3276,
                                "fully_diluted_market_cap": 0.5242425980646053,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.11177393253781598,
                                "volume_24h": 0.7399174477906934,
                                "volume_change_24h": 0.47848056049394083,
                                "percent_change_1h": 0.9211019486460588,
                                "percent_change_24h": 0.7928289600067424,
                                "percent_change_7d": 0.9349154003085534,
                                "percent_change_30d": 0.10256269568678333,
                                "market_cap": 0.4493079809812057,
                                "market_cap_dominance": 3276,
                                "fully_diluted_market_cap": 0.5242425980646053,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.11177393253781598,
                                "volume_24h": 0.7399174477906934,
                                "volume_change_24h": 0.47848056049394083,
                                "percent_change_1h": 0.9211019486460588,
                                "percent_change_24h": 0.7928289600067424,
                                "percent_change_7d": 0.9349154003085534,
                                "percent_change_30d": 0.10256269568678333,
                                "market_cap": 0.4493079809812057,
                                "market_cap_dominance": 3276,
                                "fully_diluted_market_cap": 0.5242425980646053,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.11177393253781598,
                                "volume_24h": 0.7399174477906934,
                                "volume_change_24h": 0.47848056049394083,
                                "percent_change_1h": 0.9211019486460588,
                                "percent_change_24h": 0.7928289600067424,
                                "percent_change_7d": 0.9349154003085534,
                                "percent_change_30d": 0.10256269568678333,
                                "market_cap": 0.4493079809812057,
                                "market_cap_dominance": 3276,
                                "fully_diluted_market_cap": 0.5242425980646053,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.11177393253781598,
                                "volume_24h": 0.7399174477906934,
                                "volume_change_24h": 0.47848056049394083,
                                "percent_change_1h": 0.9211019486460588,
                                "percent_change_24h": 0.7928289600067424,
                                "percent_change_7d": 0.9349154003085534,
                                "percent_change_30d": 0.10256269568678333,
                                "market_cap": 0.4493079809812057,
                                "market_cap_dominance": 3276,
                                "fully_diluted_market_cap": 0.5242425980646053,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    }
                ],
                "LTC": [
                    {
                        "id": 2786,
                        "name": "a3p2qb4cbub",
                        "symbol": "LTC",
                        "slug": "r912jee31as",
                        "is_active": 7430,
                        "is_fiat": null,
                        "circulating_supply": 9958,
                        "total_supply": 2306,
                        "max_supply": 4501,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 1988,
                        "cmc_rank": 4640,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "ito74gyaji",
                            "nw1alyn4yrm",
                            "d4ofteg2449",
                            "oygjrb2ul2f",
                            "5a3su90b0gq",
                            "0pvboixe7jk",
                            "5lk1qm3zqrj",
                            "zmzoyjw3ct",
                            "7yi1ypgls0q",
                            "g5kxggc2hsm"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.2585855760918434,
                                "volume_24h": 0.8409803992137113,
                                "volume_change_24h": 0.5488472105823616,
                                "percent_change_1h": 0.8682974006581872,
                                "percent_change_24h": 0.9237848216234643,
                                "percent_change_7d": 0.9183033523738748,
                                "percent_change_30d": 0.7070078493974288,
                                "market_cap": 0.49952556194942077,
                                "market_cap_dominance": 3381,
                                "fully_diluted_market_cap": 0.5848017618346448,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.2585855760918434,
                                "volume_24h": 0.8409803992137113,
                                "volume_change_24h": 0.5488472105823616,
                                "percent_change_1h": 0.8682974006581872,
                                "percent_change_24h": 0.9237848216234643,
                                "percent_change_7d": 0.9183033523738748,
                                "percent_change_30d": 0.7070078493974288,
                                "market_cap": 0.49952556194942077,
                                "market_cap_dominance": 3381,
                                "fully_diluted_market_cap": 0.5848017618346448,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.2585855760918434,
                                "volume_24h": 0.8409803992137113,
                                "volume_change_24h": 0.5488472105823616,
                                "percent_change_1h": 0.8682974006581872,
                                "percent_change_24h": 0.9237848216234643,
                                "percent_change_7d": 0.9183033523738748,
                                "percent_change_30d": 0.7070078493974288,
                                "market_cap": 0.49952556194942077,
                                "market_cap_dominance": 3381,
                                "fully_diluted_market_cap": 0.5848017618346448,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.2585855760918434,
                                "volume_24h": 0.8409803992137113,
                                "volume_change_24h": 0.5488472105823616,
                                "percent_change_1h": 0.8682974006581872,
                                "percent_change_24h": 0.9237848216234643,
                                "percent_change_7d": 0.9183033523738748,
                                "percent_change_30d": 0.7070078493974288,
                                "market_cap": 0.49952556194942077,
                                "market_cap_dominance": 3381,
                                "fully_diluted_market_cap": 0.5848017618346448,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.2585855760918434,
                                "volume_24h": 0.8409803992137113,
                                "volume_change_24h": 0.5488472105823616,
                                "percent_change_1h": 0.8682974006581872,
                                "percent_change_24h": 0.9237848216234643,
                                "percent_change_7d": 0.9183033523738748,
                                "percent_change_30d": 0.7070078493974288,
                                "market_cap": 0.49952556194942077,
                                "market_cap_dominance": 3381,
                                "fully_diluted_market_cap": 0.5848017618346448,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.2585855760918434,
                                "volume_24h": 0.8409803992137113,
                                "volume_change_24h": 0.5488472105823616,
                                "percent_change_1h": 0.8682974006581872,
                                "percent_change_24h": 0.9237848216234643,
                                "percent_change_7d": 0.9183033523738748,
                                "percent_change_30d": 0.7070078493974288,
                                "market_cap": 0.49952556194942077,
                                "market_cap_dominance": 3381,
                                "fully_diluted_market_cap": 0.5848017618346448,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.2585855760918434,
                                "volume_24h": 0.8409803992137113,
                                "volume_change_24h": 0.5488472105823616,
                                "percent_change_1h": 0.8682974006581872,
                                "percent_change_24h": 0.9237848216234643,
                                "percent_change_7d": 0.9183033523738748,
                                "percent_change_30d": 0.7070078493974288,
                                "market_cap": 0.49952556194942077,
                                "market_cap_dominance": 3381,
                                "fully_diluted_market_cap": 0.5848017618346448,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 5077,
                        "name": "g30kuduvslm",
                        "symbol": "LTC",
                        "slug": "8xzb4ilypmw",
                        "is_active": 3365,
                        "is_fiat": null,
                        "circulating_supply": 4116,
                        "total_supply": 3141,
                        "max_supply": 9418,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 4938,
                        "cmc_rank": 8962,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "mepvluv80ud",
                            "x3u9gl6g4i",
                            "lihy3ak4yrq",
                            "fjkzkx45ks7",
                            "6hpxsz8r43",
                            "m1hzupuz0na",
                            "y90ulh16kzp",
                            "qrzm95gvad",
                            "v5dza09ll8",
                            "1jsiu2e7oyt"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.9126483496005788,
                                "volume_24h": 0.31605669218601395,
                                "volume_change_24h": 0.3156260147348211,
                                "percent_change_1h": 0.7511368693945655,
                                "percent_change_24h": 0.14503117913926133,
                                "percent_change_7d": 0.23959169920966783,
                                "percent_change_30d": 0.9847402444043007,
                                "market_cap": 0.9974972298834117,
                                "market_cap_dominance": 7855,
                                "fully_diluted_market_cap": 0.19351864222861748,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.9126483496005788,
                                "volume_24h": 0.31605669218601395,
                                "volume_change_24h": 0.3156260147348211,
                                "percent_change_1h": 0.7511368693945655,
                                "percent_change_24h": 0.14503117913926133,
                                "percent_change_7d": 0.23959169920966783,
                                "percent_change_30d": 0.9847402444043007,
                                "market_cap": 0.9974972298834117,
                                "market_cap_dominance": 7855,
                                "fully_diluted_market_cap": 0.19351864222861748,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.9126483496005788,
                                "volume_24h": 0.31605669218601395,
                                "volume_change_24h": 0.3156260147348211,
                                "percent_change_1h": 0.7511368693945655,
                                "percent_change_24h": 0.14503117913926133,
                                "percent_change_7d": 0.23959169920966783,
                                "percent_change_30d": 0.9847402444043007,
                                "market_cap": 0.9974972298834117,
                                "market_cap_dominance": 7855,
                                "fully_diluted_market_cap": 0.19351864222861748,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.9126483496005788,
                                "volume_24h": 0.31605669218601395,
                                "volume_change_24h": 0.3156260147348211,
                                "percent_change_1h": 0.7511368693945655,
                                "percent_change_24h": 0.14503117913926133,
                                "percent_change_7d": 0.23959169920966783,
                                "percent_change_30d": 0.9847402444043007,
                                "market_cap": 0.9974972298834117,
                                "market_cap_dominance": 7855,
                                "fully_diluted_market_cap": 0.19351864222861748,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.9126483496005788,
                                "volume_24h": 0.31605669218601395,
                                "volume_change_24h": 0.3156260147348211,
                                "percent_change_1h": 0.7511368693945655,
                                "percent_change_24h": 0.14503117913926133,
                                "percent_change_7d": 0.23959169920966783,
                                "percent_change_30d": 0.9847402444043007,
                                "market_cap": 0.9974972298834117,
                                "market_cap_dominance": 7855,
                                "fully_diluted_market_cap": 0.19351864222861748,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.9126483496005788,
                                "volume_24h": 0.31605669218601395,
                                "volume_change_24h": 0.3156260147348211,
                                "percent_change_1h": 0.7511368693945655,
                                "percent_change_24h": 0.14503117913926133,
                                "percent_change_7d": 0.23959169920966783,
                                "percent_change_30d": 0.9847402444043007,
                                "market_cap": 0.9974972298834117,
                                "market_cap_dominance": 7855,
                                "fully_diluted_market_cap": 0.19351864222861748,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.9126483496005788,
                                "volume_24h": 0.31605669218601395,
                                "volume_change_24h": 0.3156260147348211,
                                "percent_change_1h": 0.7511368693945655,
                                "percent_change_24h": 0.14503117913926133,
                                "percent_change_7d": 0.23959169920966783,
                                "percent_change_30d": 0.9847402444043007,
                                "market_cap": 0.9974972298834117,
                                "market_cap_dominance": 7855,
                                "fully_diluted_market_cap": 0.19351864222861748,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 6776,
                        "name": "fx0j6ef0vek",
                        "symbol": "LTC",
                        "slug": "uligdrzl59n",
                        "is_active": 6739,
                        "is_fiat": null,
                        "circulating_supply": 9870,
                        "total_supply": 6828,
                        "max_supply": 9420,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 6573,
                        "cmc_rank": 43,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "o4ll248w6j",
                            "kkngh4ohvqi",
                            "ldtt7eyszm",
                            "2b15l9r5piq",
                            "wszik2k86fi",
                            "cp2wge4pjrv",
                            "466n2cp8grd",
                            "01uj5o3yfvib",
                            "xmevvvoy4z",
                            "5snj2z6jhqi"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.2407373445151284,
                                "volume_24h": 0.8393680762801756,
                                "volume_change_24h": 0.9169301995928014,
                                "percent_change_1h": 0.40799359425995774,
                                "percent_change_24h": 0.1606798972564185,
                                "percent_change_7d": 0.6142762732070031,
                                "percent_change_30d": 0.5293504241285276,
                                "market_cap": 0.6456957755416104,
                                "market_cap_dominance": 4239,
                                "fully_diluted_market_cap": 0.8497039155578052,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.2407373445151284,
                                "volume_24h": 0.8393680762801756,
                                "volume_change_24h": 0.9169301995928014,
                                "percent_change_1h": 0.40799359425995774,
                                "percent_change_24h": 0.1606798972564185,
                                "percent_change_7d": 0.6142762732070031,
                                "percent_change_30d": 0.5293504241285276,
                                "market_cap": 0.6456957755416104,
                                "market_cap_dominance": 4239,
                                "fully_diluted_market_cap": 0.8497039155578052,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.2407373445151284,
                                "volume_24h": 0.8393680762801756,
                                "volume_change_24h": 0.9169301995928014,
                                "percent_change_1h": 0.40799359425995774,
                                "percent_change_24h": 0.1606798972564185,
                                "percent_change_7d": 0.6142762732070031,
                                "percent_change_30d": 0.5293504241285276,
                                "market_cap": 0.6456957755416104,
                                "market_cap_dominance": 4239,
                                "fully_diluted_market_cap": 0.8497039155578052,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.2407373445151284,
                                "volume_24h": 0.8393680762801756,
                                "volume_change_24h": 0.9169301995928014,
                                "percent_change_1h": 0.40799359425995774,
                                "percent_change_24h": 0.1606798972564185,
                                "percent_change_7d": 0.6142762732070031,
                                "percent_change_30d": 0.5293504241285276,
                                "market_cap": 0.6456957755416104,
                                "market_cap_dominance": 4239,
                                "fully_diluted_market_cap": 0.8497039155578052,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.2407373445151284,
                                "volume_24h": 0.8393680762801756,
                                "volume_change_24h": 0.9169301995928014,
                                "percent_change_1h": 0.40799359425995774,
                                "percent_change_24h": 0.1606798972564185,
                                "percent_change_7d": 0.6142762732070031,
                                "percent_change_30d": 0.5293504241285276,
                                "market_cap": 0.6456957755416104,
                                "market_cap_dominance": 4239,
                                "fully_diluted_market_cap": 0.8497039155578052,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.2407373445151284,
                                "volume_24h": 0.8393680762801756,
                                "volume_change_24h": 0.9169301995928014,
                                "percent_change_1h": 0.40799359425995774,
                                "percent_change_24h": 0.1606798972564185,
                                "percent_change_7d": 0.6142762732070031,
                                "percent_change_30d": 0.5293504241285276,
                                "market_cap": 0.6456957755416104,
                                "market_cap_dominance": 4239,
                                "fully_diluted_market_cap": 0.8497039155578052,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.2407373445151284,
                                "volume_24h": 0.8393680762801756,
                                "volume_change_24h": 0.9169301995928014,
                                "percent_change_1h": 0.40799359425995774,
                                "percent_change_24h": 0.1606798972564185,
                                "percent_change_7d": 0.6142762732070031,
                                "percent_change_30d": 0.5293504241285276,
                                "market_cap": 0.6456957755416104,
                                "market_cap_dominance": 4239,
                                "fully_diluted_market_cap": 0.8497039155578052,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    }
                ],
                "SHIB": [
                    {
                        "id": 2136,
                        "name": "cxa521fbyj",
                        "symbol": "SHIB",
                        "slug": "4ubcon9edqs",
                        "is_active": 1513,
                        "is_fiat": null,
                        "circulating_supply": 3712,
                        "total_supply": 161,
                        "max_supply": 6982,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 4902,
                        "cmc_rank": 5284,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "ksasozfw07k",
                            "z0x1az09vkk",
                            "my7cudzc15",
                            "fey3mivxuhn",
                            "lrukn2d227",
                            "jyfr98jjgl",
                            "0dtjthlxralq",
                            "n0a15ivkvui",
                            "kl2ivsr7rtf",
                            "u2adznc8r8"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.5944386569432392,
                                "volume_24h": 0.019387159995902348,
                                "volume_change_24h": 0.037764976472476564,
                                "percent_change_1h": 0.2924607133078012,
                                "percent_change_24h": 0.34909309175105974,
                                "percent_change_7d": 0.4944617064131598,
                                "percent_change_30d": 0.3087999116518301,
                                "market_cap": 0.7906604986349715,
                                "market_cap_dominance": 4503,
                                "fully_diluted_market_cap": 0.6963044458233902,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.5944386569432392,
                                "volume_24h": 0.019387159995902348,
                                "volume_change_24h": 0.037764976472476564,
                                "percent_change_1h": 0.2924607133078012,
                                "percent_change_24h": 0.34909309175105974,
                                "percent_change_7d": 0.4944617064131598,
                                "percent_change_30d": 0.3087999116518301,
                                "market_cap": 0.7906604986349715,
                                "market_cap_dominance": 4503,
                                "fully_diluted_market_cap": 0.6963044458233902,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.5944386569432392,
                                "volume_24h": 0.019387159995902348,
                                "volume_change_24h": 0.037764976472476564,
                                "percent_change_1h": 0.2924607133078012,
                                "percent_change_24h": 0.34909309175105974,
                                "percent_change_7d": 0.4944617064131598,
                                "percent_change_30d": 0.3087999116518301,
                                "market_cap": 0.7906604986349715,
                                "market_cap_dominance": 4503,
                                "fully_diluted_market_cap": 0.6963044458233902,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.5944386569432392,
                                "volume_24h": 0.019387159995902348,
                                "volume_change_24h": 0.037764976472476564,
                                "percent_change_1h": 0.2924607133078012,
                                "percent_change_24h": 0.34909309175105974,
                                "percent_change_7d": 0.4944617064131598,
                                "percent_change_30d": 0.3087999116518301,
                                "market_cap": 0.7906604986349715,
                                "market_cap_dominance": 4503,
                                "fully_diluted_market_cap": 0.6963044458233902,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.5944386569432392,
                                "volume_24h": 0.019387159995902348,
                                "volume_change_24h": 0.037764976472476564,
                                "percent_change_1h": 0.2924607133078012,
                                "percent_change_24h": 0.34909309175105974,
                                "percent_change_7d": 0.4944617064131598,
                                "percent_change_30d": 0.3087999116518301,
                                "market_cap": 0.7906604986349715,
                                "market_cap_dominance": 4503,
                                "fully_diluted_market_cap": 0.6963044458233902,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.5944386569432392,
                                "volume_24h": 0.019387159995902348,
                                "volume_change_24h": 0.037764976472476564,
                                "percent_change_1h": 0.2924607133078012,
                                "percent_change_24h": 0.34909309175105974,
                                "percent_change_7d": 0.4944617064131598,
                                "percent_change_30d": 0.3087999116518301,
                                "market_cap": 0.7906604986349715,
                                "market_cap_dominance": 4503,
                                "fully_diluted_market_cap": 0.6963044458233902,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.5944386569432392,
                                "volume_24h": 0.019387159995902348,
                                "volume_change_24h": 0.037764976472476564,
                                "percent_change_1h": 0.2924607133078012,
                                "percent_change_24h": 0.34909309175105974,
                                "percent_change_7d": 0.4944617064131598,
                                "percent_change_30d": 0.3087999116518301,
                                "market_cap": 0.7906604986349715,
                                "market_cap_dominance": 4503,
                                "fully_diluted_market_cap": 0.6963044458233902,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 5709,
                        "name": "awiz1xqyl6",
                        "symbol": "SHIB",
                        "slug": "qphkw438yz8",
                        "is_active": 2969,
                        "is_fiat": null,
                        "circulating_supply": 8451,
                        "total_supply": 3006,
                        "max_supply": 7713,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 6872,
                        "cmc_rank": 1546,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "s97xy84z8d",
                            "r7b2bf9ugno",
                            "ubamy8lvf4m",
                            "lmkbk7wipzn",
                            "bft8kxzi377",
                            "ejfhg7eiiw",
                            "5dgren28niu",
                            "1qpcillw69j",
                            "3fu1g95ljm9",
                            "pvsdcssqo0h"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.8081510582018292,
                                "volume_24h": 0.8972482175419847,
                                "volume_change_24h": 0.703530624178621,
                                "percent_change_1h": 0.7355369062490977,
                                "percent_change_24h": 0.939543555554758,
                                "percent_change_7d": 0.4637596879349142,
                                "percent_change_30d": 0.2635109151163548,
                                "market_cap": 0.16959394451827725,
                                "market_cap_dominance": 7362,
                                "fully_diluted_market_cap": 0.43771027357753645,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.8081510582018292,
                                "volume_24h": 0.8972482175419847,
                                "volume_change_24h": 0.703530624178621,
                                "percent_change_1h": 0.7355369062490977,
                                "percent_change_24h": 0.939543555554758,
                                "percent_change_7d": 0.4637596879349142,
                                "percent_change_30d": 0.2635109151163548,
                                "market_cap": 0.16959394451827725,
                                "market_cap_dominance": 7362,
                                "fully_diluted_market_cap": 0.43771027357753645,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.8081510582018292,
                                "volume_24h": 0.8972482175419847,
                                "volume_change_24h": 0.703530624178621,
                                "percent_change_1h": 0.7355369062490977,
                                "percent_change_24h": 0.939543555554758,
                                "percent_change_7d": 0.4637596879349142,
                                "percent_change_30d": 0.2635109151163548,
                                "market_cap": 0.16959394451827725,
                                "market_cap_dominance": 7362,
                                "fully_diluted_market_cap": 0.43771027357753645,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.8081510582018292,
                                "volume_24h": 0.8972482175419847,
                                "volume_change_24h": 0.703530624178621,
                                "percent_change_1h": 0.7355369062490977,
                                "percent_change_24h": 0.939543555554758,
                                "percent_change_7d": 0.4637596879349142,
                                "percent_change_30d": 0.2635109151163548,
                                "market_cap": 0.16959394451827725,
                                "market_cap_dominance": 7362,
                                "fully_diluted_market_cap": 0.43771027357753645,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.8081510582018292,
                                "volume_24h": 0.8972482175419847,
                                "volume_change_24h": 0.703530624178621,
                                "percent_change_1h": 0.7355369062490977,
                                "percent_change_24h": 0.939543555554758,
                                "percent_change_7d": 0.4637596879349142,
                                "percent_change_30d": 0.2635109151163548,
                                "market_cap": 0.16959394451827725,
                                "market_cap_dominance": 7362,
                                "fully_diluted_market_cap": 0.43771027357753645,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.8081510582018292,
                                "volume_24h": 0.8972482175419847,
                                "volume_change_24h": 0.703530624178621,
                                "percent_change_1h": 0.7355369062490977,
                                "percent_change_24h": 0.939543555554758,
                                "percent_change_7d": 0.4637596879349142,
                                "percent_change_30d": 0.2635109151163548,
                                "market_cap": 0.16959394451827725,
                                "market_cap_dominance": 7362,
                                "fully_diluted_market_cap": 0.43771027357753645,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.8081510582018292,
                                "volume_24h": 0.8972482175419847,
                                "volume_change_24h": 0.703530624178621,
                                "percent_change_1h": 0.7355369062490977,
                                "percent_change_24h": 0.939543555554758,
                                "percent_change_7d": 0.4637596879349142,
                                "percent_change_30d": 0.2635109151163548,
                                "market_cap": 0.16959394451827725,
                                "market_cap_dominance": 7362,
                                "fully_diluted_market_cap": 0.43771027357753645,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 5460,
                        "name": "vee9k6wbq1q",
                        "symbol": "SHIB",
                        "slug": "0r1ene0o774",
                        "is_active": 9128,
                        "is_fiat": null,
                        "circulating_supply": 6237,
                        "total_supply": 351,
                        "max_supply": 8692,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 1490,
                        "cmc_rank": 299,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "vgouhfauo2d",
                            "7l7h534f51p",
                            "eoqkz1w6ujo",
                            "ea17mdblhxe",
                            "gslbug3dbdt",
                            "o10ys0knc8",
                            "7apw0d9k3ve",
                            "cnfya925n9b",
                            "srwjxvaeyml",
                            "3izrjfh65ig"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.34345907084718563,
                                "volume_24h": 0.801040710837714,
                                "volume_change_24h": 0.04969198548723153,
                                "percent_change_1h": 0.9538295518283388,
                                "percent_change_24h": 0.8790346503349653,
                                "percent_change_7d": 0.4366347169871432,
                                "percent_change_30d": 0.16120536976750754,
                                "market_cap": 0.47370412935382356,
                                "market_cap_dominance": 8766,
                                "fully_diluted_market_cap": 0.6202060021056164,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.34345907084718563,
                                "volume_24h": 0.801040710837714,
                                "volume_change_24h": 0.04969198548723153,
                                "percent_change_1h": 0.9538295518283388,
                                "percent_change_24h": 0.8790346503349653,
                                "percent_change_7d": 0.4366347169871432,
                                "percent_change_30d": 0.16120536976750754,
                                "market_cap": 0.47370412935382356,
                                "market_cap_dominance": 8766,
                                "fully_diluted_market_cap": 0.6202060021056164,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.34345907084718563,
                                "volume_24h": 0.801040710837714,
                                "volume_change_24h": 0.04969198548723153,
                                "percent_change_1h": 0.9538295518283388,
                                "percent_change_24h": 0.8790346503349653,
                                "percent_change_7d": 0.4366347169871432,
                                "percent_change_30d": 0.16120536976750754,
                                "market_cap": 0.47370412935382356,
                                "market_cap_dominance": 8766,
                                "fully_diluted_market_cap": 0.6202060021056164,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.34345907084718563,
                                "volume_24h": 0.801040710837714,
                                "volume_change_24h": 0.04969198548723153,
                                "percent_change_1h": 0.9538295518283388,
                                "percent_change_24h": 0.8790346503349653,
                                "percent_change_7d": 0.4366347169871432,
                                "percent_change_30d": 0.16120536976750754,
                                "market_cap": 0.47370412935382356,
                                "market_cap_dominance": 8766,
                                "fully_diluted_market_cap": 0.6202060021056164,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.34345907084718563,
                                "volume_24h": 0.801040710837714,
                                "volume_change_24h": 0.04969198548723153,
                                "percent_change_1h": 0.9538295518283388,
                                "percent_change_24h": 0.8790346503349653,
                                "percent_change_7d": 0.4366347169871432,
                                "percent_change_30d": 0.16120536976750754,
                                "market_cap": 0.47370412935382356,
                                "market_cap_dominance": 8766,
                                "fully_diluted_market_cap": 0.6202060021056164,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.34345907084718563,
                                "volume_24h": 0.801040710837714,
                                "volume_change_24h": 0.04969198548723153,
                                "percent_change_1h": 0.9538295518283388,
                                "percent_change_24h": 0.8790346503349653,
                                "percent_change_7d": 0.4366347169871432,
                                "percent_change_30d": 0.16120536976750754,
                                "market_cap": 0.47370412935382356,
                                "market_cap_dominance": 8766,
                                "fully_diluted_market_cap": 0.6202060021056164,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.34345907084718563,
                                "volume_24h": 0.801040710837714,
                                "volume_change_24h": 0.04969198548723153,
                                "percent_change_1h": 0.9538295518283388,
                                "percent_change_24h": 0.8790346503349653,
                                "percent_change_7d": 0.4366347169871432,
                                "percent_change_30d": 0.16120536976750754,
                                "market_cap": 0.47370412935382356,
                                "market_cap_dominance": 8766,
                                "fully_diluted_market_cap": 0.6202060021056164,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    }
                ],
                "USDC": [
                    {
                        "id": 4304,
                        "name": "x19y7wceheh",
                        "symbol": "USDC",
                        "slug": "7axjg8ekge5",
                        "is_active": 5787,
                        "is_fiat": null,
                        "circulating_supply": 3925,
                        "total_supply": 3623,
                        "max_supply": 2901,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 3878,
                        "cmc_rank": 1870,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "q165a42qtr",
                            "dvpwg0vo1hq",
                            "uhw2mcue0n",
                            "laerx3473zr",
                            "m1pydb3fqt",
                            "9ly5582lfoa",
                            "v8hvba50kdn",
                            "e4e3xgkyriw",
                            "lt8y8vae34i",
                            "kpwizqrxx4"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.4969647486936313,
                                "volume_24h": 0.2421170256944103,
                                "volume_change_24h": 0.868400765840925,
                                "percent_change_1h": 0.7707812967228109,
                                "percent_change_24h": 0.9853595380534941,
                                "percent_change_7d": 0.48121169308755674,
                                "percent_change_30d": 0.1341701322972968,
                                "market_cap": 0.7175987169403295,
                                "market_cap_dominance": 421,
                                "fully_diluted_market_cap": 0.7149766732384832,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.4969647486936313,
                                "volume_24h": 0.2421170256944103,
                                "volume_change_24h": 0.868400765840925,
                                "percent_change_1h": 0.7707812967228109,
                                "percent_change_24h": 0.9853595380534941,
                                "percent_change_7d": 0.48121169308755674,
                                "percent_change_30d": 0.1341701322972968,
                                "market_cap": 0.7175987169403295,
                                "market_cap_dominance": 421,
                                "fully_diluted_market_cap": 0.7149766732384832,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.4969647486936313,
                                "volume_24h": 0.2421170256944103,
                                "volume_change_24h": 0.868400765840925,
                                "percent_change_1h": 0.7707812967228109,
                                "percent_change_24h": 0.9853595380534941,
                                "percent_change_7d": 0.48121169308755674,
                                "percent_change_30d": 0.1341701322972968,
                                "market_cap": 0.7175987169403295,
                                "market_cap_dominance": 421,
                                "fully_diluted_market_cap": 0.7149766732384832,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.4969647486936313,
                                "volume_24h": 0.2421170256944103,
                                "volume_change_24h": 0.868400765840925,
                                "percent_change_1h": 0.7707812967228109,
                                "percent_change_24h": 0.9853595380534941,
                                "percent_change_7d": 0.48121169308755674,
                                "percent_change_30d": 0.1341701322972968,
                                "market_cap": 0.7175987169403295,
                                "market_cap_dominance": 421,
                                "fully_diluted_market_cap": 0.7149766732384832,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.4969647486936313,
                                "volume_24h": 0.2421170256944103,
                                "volume_change_24h": 0.868400765840925,
                                "percent_change_1h": 0.7707812967228109,
                                "percent_change_24h": 0.9853595380534941,
                                "percent_change_7d": 0.48121169308755674,
                                "percent_change_30d": 0.1341701322972968,
                                "market_cap": 0.7175987169403295,
                                "market_cap_dominance": 421,
                                "fully_diluted_market_cap": 0.7149766732384832,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.4969647486936313,
                                "volume_24h": 0.2421170256944103,
                                "volume_change_24h": 0.868400765840925,
                                "percent_change_1h": 0.7707812967228109,
                                "percent_change_24h": 0.9853595380534941,
                                "percent_change_7d": 0.48121169308755674,
                                "percent_change_30d": 0.1341701322972968,
                                "market_cap": 0.7175987169403295,
                                "market_cap_dominance": 421,
                                "fully_diluted_market_cap": 0.7149766732384832,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.4969647486936313,
                                "volume_24h": 0.2421170256944103,
                                "volume_change_24h": 0.868400765840925,
                                "percent_change_1h": 0.7707812967228109,
                                "percent_change_24h": 0.9853595380534941,
                                "percent_change_7d": 0.48121169308755674,
                                "percent_change_30d": 0.1341701322972968,
                                "market_cap": 0.7175987169403295,
                                "market_cap_dominance": 421,
                                "fully_diluted_market_cap": 0.7149766732384832,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 7371,
                        "name": "n0sztic3dpq",
                        "symbol": "USDC",
                        "slug": "e08v09yb6b",
                        "is_active": 3390,
                        "is_fiat": null,
                        "circulating_supply": 3937,
                        "total_supply": 8369,
                        "max_supply": 7218,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 3707,
                        "cmc_rank": 7707,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "y9p7tdyyar8",
                            "5xpo7o3fs2p",
                            "v1kueftskzb",
                            "9d6kt6ficns",
                            "ouyg7xmfvj9",
                            "g7nv22f181c",
                            "zgqupeciaee",
                            "2qq6mv7lpe4",
                            "ngazlomza0c",
                            "34gu4hvlab4"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.4292501048529549,
                                "volume_24h": 0.1634555245037863,
                                "volume_change_24h": 0.6655985034884027,
                                "percent_change_1h": 0.4257327240193356,
                                "percent_change_24h": 0.076632718101173,
                                "percent_change_7d": 0.3244096247624355,
                                "percent_change_30d": 0.916955788705401,
                                "market_cap": 0.9818435026888566,
                                "market_cap_dominance": 3000,
                                "fully_diluted_market_cap": 0.13559908658728248,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.4292501048529549,
                                "volume_24h": 0.1634555245037863,
                                "volume_change_24h": 0.6655985034884027,
                                "percent_change_1h": 0.4257327240193356,
                                "percent_change_24h": 0.076632718101173,
                                "percent_change_7d": 0.3244096247624355,
                                "percent_change_30d": 0.916955788705401,
                                "market_cap": 0.9818435026888566,
                                "market_cap_dominance": 3000,
                                "fully_diluted_market_cap": 0.13559908658728248,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.4292501048529549,
                                "volume_24h": 0.1634555245037863,
                                "volume_change_24h": 0.6655985034884027,
                                "percent_change_1h": 0.4257327240193356,
                                "percent_change_24h": 0.076632718101173,
                                "percent_change_7d": 0.3244096247624355,
                                "percent_change_30d": 0.916955788705401,
                                "market_cap": 0.9818435026888566,
                                "market_cap_dominance": 3000,
                                "fully_diluted_market_cap": 0.13559908658728248,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.4292501048529549,
                                "volume_24h": 0.1634555245037863,
                                "volume_change_24h": 0.6655985034884027,
                                "percent_change_1h": 0.4257327240193356,
                                "percent_change_24h": 0.076632718101173,
                                "percent_change_7d": 0.3244096247624355,
                                "percent_change_30d": 0.916955788705401,
                                "market_cap": 0.9818435026888566,
                                "market_cap_dominance": 3000,
                                "fully_diluted_market_cap": 0.13559908658728248,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.4292501048529549,
                                "volume_24h": 0.1634555245037863,
                                "volume_change_24h": 0.6655985034884027,
                                "percent_change_1h": 0.4257327240193356,
                                "percent_change_24h": 0.076632718101173,
                                "percent_change_7d": 0.3244096247624355,
                                "percent_change_30d": 0.916955788705401,
                                "market_cap": 0.9818435026888566,
                                "market_cap_dominance": 3000,
                                "fully_diluted_market_cap": 0.13559908658728248,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.4292501048529549,
                                "volume_24h": 0.1634555245037863,
                                "volume_change_24h": 0.6655985034884027,
                                "percent_change_1h": 0.4257327240193356,
                                "percent_change_24h": 0.076632718101173,
                                "percent_change_7d": 0.3244096247624355,
                                "percent_change_30d": 0.916955788705401,
                                "market_cap": 0.9818435026888566,
                                "market_cap_dominance": 3000,
                                "fully_diluted_market_cap": 0.13559908658728248,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.4292501048529549,
                                "volume_24h": 0.1634555245037863,
                                "volume_change_24h": 0.6655985034884027,
                                "percent_change_1h": 0.4257327240193356,
                                "percent_change_24h": 0.076632718101173,
                                "percent_change_7d": 0.3244096247624355,
                                "percent_change_30d": 0.916955788705401,
                                "market_cap": 0.9818435026888566,
                                "market_cap_dominance": 3000,
                                "fully_diluted_market_cap": 0.13559908658728248,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 8737,
                        "name": "o8vps10zqo",
                        "symbol": "USDC",
                        "slug": "y14xlkhiw6",
                        "is_active": 6683,
                        "is_fiat": null,
                        "circulating_supply": 5751,
                        "total_supply": 5525,
                        "max_supply": 1277,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 5148,
                        "cmc_rank": 4212,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "2csjxspsf57",
                            "6j2cv9bshkl",
                            "sg7s47ezpp",
                            "j0nyh052zd",
                            "3xy0qy9snky",
                            "yl7mnbzvgl",
                            "0q9ozeomjgj",
                            "nrsttgq6pk",
                            "cpbi9pfwz1h",
                            "ji3odlsazxm"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.4997137408194028,
                                "volume_24h": 0.7625894800212583,
                                "volume_change_24h": 0.7314982449589378,
                                "percent_change_1h": 0.7837552655809863,
                                "percent_change_24h": 0.033732471649033924,
                                "percent_change_7d": 0.4232164231672668,
                                "percent_change_30d": 0.6724956970970648,
                                "market_cap": 0.5620245112221642,
                                "market_cap_dominance": 391,
                                "fully_diluted_market_cap": 0.6252056537557105,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.4997137408194028,
                                "volume_24h": 0.7625894800212583,
                                "volume_change_24h": 0.7314982449589378,
                                "percent_change_1h": 0.7837552655809863,
                                "percent_change_24h": 0.033732471649033924,
                                "percent_change_7d": 0.4232164231672668,
                                "percent_change_30d": 0.6724956970970648,
                                "market_cap": 0.5620245112221642,
                                "market_cap_dominance": 391,
                                "fully_diluted_market_cap": 0.6252056537557105,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.4997137408194028,
                                "volume_24h": 0.7625894800212583,
                                "volume_change_24h": 0.7314982449589378,
                                "percent_change_1h": 0.7837552655809863,
                                "percent_change_24h": 0.033732471649033924,
                                "percent_change_7d": 0.4232164231672668,
                                "percent_change_30d": 0.6724956970970648,
                                "market_cap": 0.5620245112221642,
                                "market_cap_dominance": 391,
                                "fully_diluted_market_cap": 0.6252056537557105,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.4997137408194028,
                                "volume_24h": 0.7625894800212583,
                                "volume_change_24h": 0.7314982449589378,
                                "percent_change_1h": 0.7837552655809863,
                                "percent_change_24h": 0.033732471649033924,
                                "percent_change_7d": 0.4232164231672668,
                                "percent_change_30d": 0.6724956970970648,
                                "market_cap": 0.5620245112221642,
                                "market_cap_dominance": 391,
                                "fully_diluted_market_cap": 0.6252056537557105,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.4997137408194028,
                                "volume_24h": 0.7625894800212583,
                                "volume_change_24h": 0.7314982449589378,
                                "percent_change_1h": 0.7837552655809863,
                                "percent_change_24h": 0.033732471649033924,
                                "percent_change_7d": 0.4232164231672668,
                                "percent_change_30d": 0.6724956970970648,
                                "market_cap": 0.5620245112221642,
                                "market_cap_dominance": 391,
                                "fully_diluted_market_cap": 0.6252056537557105,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.4997137408194028,
                                "volume_24h": 0.7625894800212583,
                                "volume_change_24h": 0.7314982449589378,
                                "percent_change_1h": 0.7837552655809863,
                                "percent_change_24h": 0.033732471649033924,
                                "percent_change_7d": 0.4232164231672668,
                                "percent_change_30d": 0.6724956970970648,
                                "market_cap": 0.5620245112221642,
                                "market_cap_dominance": 391,
                                "fully_diluted_market_cap": 0.6252056537557105,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.4997137408194028,
                                "volume_24h": 0.7625894800212583,
                                "volume_change_24h": 0.7314982449589378,
                                "percent_change_1h": 0.7837552655809863,
                                "percent_change_24h": 0.033732471649033924,
                                "percent_change_7d": 0.4232164231672668,
                                "percent_change_30d": 0.6724956970970648,
                                "market_cap": 0.5620245112221642,
                                "market_cap_dominance": 391,
                                "fully_diluted_market_cap": 0.6252056537557105,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    }
                ],
                "USDP": [
                    {
                        "id": 8551,
                        "name": "raps7e76pv",
                        "symbol": "USDP",
                        "slug": "vupwnbbkpjk",
                        "is_active": 2031,
                        "is_fiat": null,
                        "circulating_supply": 5821,
                        "total_supply": 1033,
                        "max_supply": 380,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 6524,
                        "cmc_rank": 4488,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "3zheowadkvd",
                            "fcj51y1qdm7",
                            "q4uhtiaijni",
                            "jpy8faj39k",
                            "piykdc4a3wi",
                            "h8iwahm1htv",
                            "donjnupjrb",
                            "j276yjywmrr",
                            "okybtg7ro09",
                            "7vjdgw6z3y3"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.6610929071666307,
                                "volume_24h": 0.7247047613973672,
                                "volume_change_24h": 0.10073137723272141,
                                "percent_change_1h": 0.18138260307125242,
                                "percent_change_24h": 0.47689811033247254,
                                "percent_change_7d": 0.43163874466907126,
                                "percent_change_30d": 0.5082131132664209,
                                "market_cap": 0.0858685940596382,
                                "market_cap_dominance": 3320,
                                "fully_diluted_market_cap": 0.8054239224638164,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.6610929071666307,
                                "volume_24h": 0.7247047613973672,
                                "volume_change_24h": 0.10073137723272141,
                                "percent_change_1h": 0.18138260307125242,
                                "percent_change_24h": 0.47689811033247254,
                                "percent_change_7d": 0.43163874466907126,
                                "percent_change_30d": 0.5082131132664209,
                                "market_cap": 0.0858685940596382,
                                "market_cap_dominance": 3320,
                                "fully_diluted_market_cap": 0.8054239224638164,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.6610929071666307,
                                "volume_24h": 0.7247047613973672,
                                "volume_change_24h": 0.10073137723272141,
                                "percent_change_1h": 0.18138260307125242,
                                "percent_change_24h": 0.47689811033247254,
                                "percent_change_7d": 0.43163874466907126,
                                "percent_change_30d": 0.5082131132664209,
                                "market_cap": 0.0858685940596382,
                                "market_cap_dominance": 3320,
                                "fully_diluted_market_cap": 0.8054239224638164,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.6610929071666307,
                                "volume_24h": 0.7247047613973672,
                                "volume_change_24h": 0.10073137723272141,
                                "percent_change_1h": 0.18138260307125242,
                                "percent_change_24h": 0.47689811033247254,
                                "percent_change_7d": 0.43163874466907126,
                                "percent_change_30d": 0.5082131132664209,
                                "market_cap": 0.0858685940596382,
                                "market_cap_dominance": 3320,
                                "fully_diluted_market_cap": 0.8054239224638164,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.6610929071666307,
                                "volume_24h": 0.7247047613973672,
                                "volume_change_24h": 0.10073137723272141,
                                "percent_change_1h": 0.18138260307125242,
                                "percent_change_24h": 0.47689811033247254,
                                "percent_change_7d": 0.43163874466907126,
                                "percent_change_30d": 0.5082131132664209,
                                "market_cap": 0.0858685940596382,
                                "market_cap_dominance": 3320,
                                "fully_diluted_market_cap": 0.8054239224638164,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.6610929071666307,
                                "volume_24h": 0.7247047613973672,
                                "volume_change_24h": 0.10073137723272141,
                                "percent_change_1h": 0.18138260307125242,
                                "percent_change_24h": 0.47689811033247254,
                                "percent_change_7d": 0.43163874466907126,
                                "percent_change_30d": 0.5082131132664209,
                                "market_cap": 0.0858685940596382,
                                "market_cap_dominance": 3320,
                                "fully_diluted_market_cap": 0.8054239224638164,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.6610929071666307,
                                "volume_24h": 0.7247047613973672,
                                "volume_change_24h": 0.10073137723272141,
                                "percent_change_1h": 0.18138260307125242,
                                "percent_change_24h": 0.47689811033247254,
                                "percent_change_7d": 0.43163874466907126,
                                "percent_change_30d": 0.5082131132664209,
                                "market_cap": 0.0858685940596382,
                                "market_cap_dominance": 3320,
                                "fully_diluted_market_cap": 0.8054239224638164,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 2,
                        "name": "fzuvhw7ptyh",
                        "symbol": "USDP",
                        "slug": "9dff95edmdp",
                        "is_active": 4986,
                        "is_fiat": null,
                        "circulating_supply": 2036,
                        "total_supply": 3313,
                        "max_supply": 9783,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 3963,
                        "cmc_rank": 7130,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "0ramv6iyzm5",
                            "m9lwyx5jhr",
                            "k1mc8ad1a8",
                            "ubgeyuec2f",
                            "4zctgrd9dmh",
                            "tl8s4l6z37",
                            "0epgosh7s4dt",
                            "je9s5iutlbg",
                            "xvwp2kgas2",
                            "rju6jlk3tsm"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.45359889000981957,
                                "volume_24h": 0.3247808091413149,
                                "volume_change_24h": 0.4937823234709844,
                                "percent_change_1h": 0.01703288083083665,
                                "percent_change_24h": 0.28651835929072145,
                                "percent_change_7d": 0.8454035024214728,
                                "percent_change_30d": 0.6773281378267597,
                                "market_cap": 0.19595519040576503,
                                "market_cap_dominance": 709,
                                "fully_diluted_market_cap": 0.2787329439693831,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.45359889000981957,
                                "volume_24h": 0.3247808091413149,
                                "volume_change_24h": 0.4937823234709844,
                                "percent_change_1h": 0.01703288083083665,
                                "percent_change_24h": 0.28651835929072145,
                                "percent_change_7d": 0.8454035024214728,
                                "percent_change_30d": 0.6773281378267597,
                                "market_cap": 0.19595519040576503,
                                "market_cap_dominance": 709,
                                "fully_diluted_market_cap": 0.2787329439693831,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.45359889000981957,
                                "volume_24h": 0.3247808091413149,
                                "volume_change_24h": 0.4937823234709844,
                                "percent_change_1h": 0.01703288083083665,
                                "percent_change_24h": 0.28651835929072145,
                                "percent_change_7d": 0.8454035024214728,
                                "percent_change_30d": 0.6773281378267597,
                                "market_cap": 0.19595519040576503,
                                "market_cap_dominance": 709,
                                "fully_diluted_market_cap": 0.2787329439693831,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.45359889000981957,
                                "volume_24h": 0.3247808091413149,
                                "volume_change_24h": 0.4937823234709844,
                                "percent_change_1h": 0.01703288083083665,
                                "percent_change_24h": 0.28651835929072145,
                                "percent_change_7d": 0.8454035024214728,
                                "percent_change_30d": 0.6773281378267597,
                                "market_cap": 0.19595519040576503,
                                "market_cap_dominance": 709,
                                "fully_diluted_market_cap": 0.2787329439693831,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.45359889000981957,
                                "volume_24h": 0.3247808091413149,
                                "volume_change_24h": 0.4937823234709844,
                                "percent_change_1h": 0.01703288083083665,
                                "percent_change_24h": 0.28651835929072145,
                                "percent_change_7d": 0.8454035024214728,
                                "percent_change_30d": 0.6773281378267597,
                                "market_cap": 0.19595519040576503,
                                "market_cap_dominance": 709,
                                "fully_diluted_market_cap": 0.2787329439693831,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.45359889000981957,
                                "volume_24h": 0.3247808091413149,
                                "volume_change_24h": 0.4937823234709844,
                                "percent_change_1h": 0.01703288083083665,
                                "percent_change_24h": 0.28651835929072145,
                                "percent_change_7d": 0.8454035024214728,
                                "percent_change_30d": 0.6773281378267597,
                                "market_cap": 0.19595519040576503,
                                "market_cap_dominance": 709,
                                "fully_diluted_market_cap": 0.2787329439693831,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.45359889000981957,
                                "volume_24h": 0.3247808091413149,
                                "volume_change_24h": 0.4937823234709844,
                                "percent_change_1h": 0.01703288083083665,
                                "percent_change_24h": 0.28651835929072145,
                                "percent_change_7d": 0.8454035024214728,
                                "percent_change_30d": 0.6773281378267597,
                                "market_cap": 0.19595519040576503,
                                "market_cap_dominance": 709,
                                "fully_diluted_market_cap": 0.2787329439693831,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 5322,
                        "name": "ffzimmmlyjj",
                        "symbol": "USDP",
                        "slug": "9qbjv4a03",
                        "is_active": 6443,
                        "is_fiat": null,
                        "circulating_supply": 6283,
                        "total_supply": 4052,
                        "max_supply": 5854,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 4754,
                        "cmc_rank": 3323,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "uko9h83o0pc",
                            "m6j0g0yj8zf",
                            "j0fj07g8d5",
                            "2evw0g93wd3",
                            "pb4ig3t6ot",
                            "0h6kfxcaiqp4",
                            "m3b7rjhadq",
                            "rs7zxaqziq",
                            "zwo72efct4e",
                            "2mkgv57v9t3"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.3005781923626687,
                                "volume_24h": 0.5059219449042698,
                                "volume_change_24h": 0.1699087498890155,
                                "percent_change_1h": 0.5638009583020493,
                                "percent_change_24h": 0.9895834058978217,
                                "percent_change_7d": 0.0037516867559801437,
                                "percent_change_30d": 0.7072674374495311,
                                "market_cap": 0.27010773907972996,
                                "market_cap_dominance": 1079,
                                "fully_diluted_market_cap": 0.8306563543689582,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.3005781923626687,
                                "volume_24h": 0.5059219449042698,
                                "volume_change_24h": 0.1699087498890155,
                                "percent_change_1h": 0.5638009583020493,
                                "percent_change_24h": 0.9895834058978217,
                                "percent_change_7d": 0.0037516867559801437,
                                "percent_change_30d": 0.7072674374495311,
                                "market_cap": 0.27010773907972996,
                                "market_cap_dominance": 1079,
                                "fully_diluted_market_cap": 0.8306563543689582,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.3005781923626687,
                                "volume_24h": 0.5059219449042698,
                                "volume_change_24h": 0.1699087498890155,
                                "percent_change_1h": 0.5638009583020493,
                                "percent_change_24h": 0.9895834058978217,
                                "percent_change_7d": 0.0037516867559801437,
                                "percent_change_30d": 0.7072674374495311,
                                "market_cap": 0.27010773907972996,
                                "market_cap_dominance": 1079,
                                "fully_diluted_market_cap": 0.8306563543689582,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.3005781923626687,
                                "volume_24h": 0.5059219449042698,
                                "volume_change_24h": 0.1699087498890155,
                                "percent_change_1h": 0.5638009583020493,
                                "percent_change_24h": 0.9895834058978217,
                                "percent_change_7d": 0.0037516867559801437,
                                "percent_change_30d": 0.7072674374495311,
                                "market_cap": 0.27010773907972996,
                                "market_cap_dominance": 1079,
                                "fully_diluted_market_cap": 0.8306563543689582,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.3005781923626687,
                                "volume_24h": 0.5059219449042698,
                                "volume_change_24h": 0.1699087498890155,
                                "percent_change_1h": 0.5638009583020493,
                                "percent_change_24h": 0.9895834058978217,
                                "percent_change_7d": 0.0037516867559801437,
                                "percent_change_30d": 0.7072674374495311,
                                "market_cap": 0.27010773907972996,
                                "market_cap_dominance": 1079,
                                "fully_diluted_market_cap": 0.8306563543689582,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.3005781923626687,
                                "volume_24h": 0.5059219449042698,
                                "volume_change_24h": 0.1699087498890155,
                                "percent_change_1h": 0.5638009583020493,
                                "percent_change_24h": 0.9895834058978217,
                                "percent_change_7d": 0.0037516867559801437,
                                "percent_change_30d": 0.7072674374495311,
                                "market_cap": 0.27010773907972996,
                                "market_cap_dominance": 1079,
                                "fully_diluted_market_cap": 0.8306563543689582,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.3005781923626687,
                                "volume_24h": 0.5059219449042698,
                                "volume_change_24h": 0.1699087498890155,
                                "percent_change_1h": 0.5638009583020493,
                                "percent_change_24h": 0.9895834058978217,
                                "percent_change_7d": 0.0037516867559801437,
                                "percent_change_30d": 0.7072674374495311,
                                "market_cap": 0.27010773907972996,
                                "market_cap_dominance": 1079,
                                "fully_diluted_market_cap": 0.8306563543689582,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    }
                ],
                "WBTC": [
                    {
                        "id": 171,
                        "name": "cpc7ew7n62u",
                        "symbol": "WBTC",
                        "slug": "3ea5sy5r1j9",
                        "is_active": 1858,
                        "is_fiat": null,
                        "circulating_supply": 5053,
                        "total_supply": 3743,
                        "max_supply": 9560,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 8733,
                        "cmc_rank": 9649,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "6bw2pvx3ty",
                            "k0bgkq0x0bs",
                            "tzkqqmo0p9",
                            "eupo8tqmgrc",
                            "obwwynk81w",
                            "1lurbvkycr2",
                            "7elo0icxzlu",
                            "s7pkhhldgo",
                            "t4uekdciwro",
                            "dcritew8qc8"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.4178347565136977,
                                "volume_24h": 0.6697533873168053,
                                "volume_change_24h": 0.15657507329694864,
                                "percent_change_1h": 0.8525840459097642,
                                "percent_change_24h": 0.4316846862587145,
                                "percent_change_7d": 0.13344223374053032,
                                "percent_change_30d": 0.8151751291094445,
                                "market_cap": 0.8710708825254672,
                                "market_cap_dominance": 8909,
                                "fully_diluted_market_cap": 0.169541486327339,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.4178347565136977,
                                "volume_24h": 0.6697533873168053,
                                "volume_change_24h": 0.15657507329694864,
                                "percent_change_1h": 0.8525840459097642,
                                "percent_change_24h": 0.4316846862587145,
                                "percent_change_7d": 0.13344223374053032,
                                "percent_change_30d": 0.8151751291094445,
                                "market_cap": 0.8710708825254672,
                                "market_cap_dominance": 8909,
                                "fully_diluted_market_cap": 0.169541486327339,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.4178347565136977,
                                "volume_24h": 0.6697533873168053,
                                "volume_change_24h": 0.15657507329694864,
                                "percent_change_1h": 0.8525840459097642,
                                "percent_change_24h": 0.4316846862587145,
                                "percent_change_7d": 0.13344223374053032,
                                "percent_change_30d": 0.8151751291094445,
                                "market_cap": 0.8710708825254672,
                                "market_cap_dominance": 8909,
                                "fully_diluted_market_cap": 0.169541486327339,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.4178347565136977,
                                "volume_24h": 0.6697533873168053,
                                "volume_change_24h": 0.15657507329694864,
                                "percent_change_1h": 0.8525840459097642,
                                "percent_change_24h": 0.4316846862587145,
                                "percent_change_7d": 0.13344223374053032,
                                "percent_change_30d": 0.8151751291094445,
                                "market_cap": 0.8710708825254672,
                                "market_cap_dominance": 8909,
                                "fully_diluted_market_cap": 0.169541486327339,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.4178347565136977,
                                "volume_24h": 0.6697533873168053,
                                "volume_change_24h": 0.15657507329694864,
                                "percent_change_1h": 0.8525840459097642,
                                "percent_change_24h": 0.4316846862587145,
                                "percent_change_7d": 0.13344223374053032,
                                "percent_change_30d": 0.8151751291094445,
                                "market_cap": 0.8710708825254672,
                                "market_cap_dominance": 8909,
                                "fully_diluted_market_cap": 0.169541486327339,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.4178347565136977,
                                "volume_24h": 0.6697533873168053,
                                "volume_change_24h": 0.15657507329694864,
                                "percent_change_1h": 0.8525840459097642,
                                "percent_change_24h": 0.4316846862587145,
                                "percent_change_7d": 0.13344223374053032,
                                "percent_change_30d": 0.8151751291094445,
                                "market_cap": 0.8710708825254672,
                                "market_cap_dominance": 8909,
                                "fully_diluted_market_cap": 0.169541486327339,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.4178347565136977,
                                "volume_24h": 0.6697533873168053,
                                "volume_change_24h": 0.15657507329694864,
                                "percent_change_1h": 0.8525840459097642,
                                "percent_change_24h": 0.4316846862587145,
                                "percent_change_7d": 0.13344223374053032,
                                "percent_change_30d": 0.8151751291094445,
                                "market_cap": 0.8710708825254672,
                                "market_cap_dominance": 8909,
                                "fully_diluted_market_cap": 0.169541486327339,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 5902,
                        "name": "lp1qpkrepy",
                        "symbol": "WBTC",
                        "slug": "m2roaebhjyr",
                        "is_active": 9386,
                        "is_fiat": null,
                        "circulating_supply": 5621,
                        "total_supply": 5799,
                        "max_supply": 8460,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 6808,
                        "cmc_rank": 2259,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "m57fy4vb689",
                            "6t0uo9w2o98",
                            "49ge1sumfox",
                            "gbxzvvcsgmj",
                            "af9v69gvias",
                            "qk4kp7nhd5",
                            "8kkq0f13xsj",
                            "fivspzclz6l",
                            "2ikj1i61si6",
                            "udruj3v7yi"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.14384447654582866,
                                "volume_24h": 0.6523303213185176,
                                "volume_change_24h": 0.13157482608813398,
                                "percent_change_1h": 0.29871747417383965,
                                "percent_change_24h": 0.7734903897310053,
                                "percent_change_7d": 0.951733407504898,
                                "percent_change_30d": 0.10457935155516696,
                                "market_cap": 0.9893555735023241,
                                "market_cap_dominance": 2022,
                                "fully_diluted_market_cap": 0.276199404238908,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.14384447654582866,
                                "volume_24h": 0.6523303213185176,
                                "volume_change_24h": 0.13157482608813398,
                                "percent_change_1h": 0.29871747417383965,
                                "percent_change_24h": 0.7734903897310053,
                                "percent_change_7d": 0.951733407504898,
                                "percent_change_30d": 0.10457935155516696,
                                "market_cap": 0.9893555735023241,
                                "market_cap_dominance": 2022,
                                "fully_diluted_market_cap": 0.276199404238908,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.14384447654582866,
                                "volume_24h": 0.6523303213185176,
                                "volume_change_24h": 0.13157482608813398,
                                "percent_change_1h": 0.29871747417383965,
                                "percent_change_24h": 0.7734903897310053,
                                "percent_change_7d": 0.951733407504898,
                                "percent_change_30d": 0.10457935155516696,
                                "market_cap": 0.9893555735023241,
                                "market_cap_dominance": 2022,
                                "fully_diluted_market_cap": 0.276199404238908,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.14384447654582866,
                                "volume_24h": 0.6523303213185176,
                                "volume_change_24h": 0.13157482608813398,
                                "percent_change_1h": 0.29871747417383965,
                                "percent_change_24h": 0.7734903897310053,
                                "percent_change_7d": 0.951733407504898,
                                "percent_change_30d": 0.10457935155516696,
                                "market_cap": 0.9893555735023241,
                                "market_cap_dominance": 2022,
                                "fully_diluted_market_cap": 0.276199404238908,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.14384447654582866,
                                "volume_24h": 0.6523303213185176,
                                "volume_change_24h": 0.13157482608813398,
                                "percent_change_1h": 0.29871747417383965,
                                "percent_change_24h": 0.7734903897310053,
                                "percent_change_7d": 0.951733407504898,
                                "percent_change_30d": 0.10457935155516696,
                                "market_cap": 0.9893555735023241,
                                "market_cap_dominance": 2022,
                                "fully_diluted_market_cap": 0.276199404238908,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.14384447654582866,
                                "volume_24h": 0.6523303213185176,
                                "volume_change_24h": 0.13157482608813398,
                                "percent_change_1h": 0.29871747417383965,
                                "percent_change_24h": 0.7734903897310053,
                                "percent_change_7d": 0.951733407504898,
                                "percent_change_30d": 0.10457935155516696,
                                "market_cap": 0.9893555735023241,
                                "market_cap_dominance": 2022,
                                "fully_diluted_market_cap": 0.276199404238908,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.14384447654582866,
                                "volume_24h": 0.6523303213185176,
                                "volume_change_24h": 0.13157482608813398,
                                "percent_change_1h": 0.29871747417383965,
                                "percent_change_24h": 0.7734903897310053,
                                "percent_change_7d": 0.951733407504898,
                                "percent_change_30d": 0.10457935155516696,
                                "market_cap": 0.9893555735023241,
                                "market_cap_dominance": 2022,
                                "fully_diluted_market_cap": 0.276199404238908,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 8259,
                        "name": "33rqa3wc0yd",
                        "symbol": "WBTC",
                        "slug": "nbmutdozwwh",
                        "is_active": 7224,
                        "is_fiat": null,
                        "circulating_supply": 9557,
                        "total_supply": 7398,
                        "max_supply": 9463,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 9058,
                        "cmc_rank": 7529,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "004pme7e2e6e3",
                            "s4zqiyvypuc",
                            "9w9ta98pwha",
                            "bw8p56h9djf",
                            "yffnp3cr6d",
                            "hgwpv6khhw",
                            "301n218pnz4",
                            "7j5s8hqgp0x",
                            "xaeghwofadp",
                            "tcf90fcjirr"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.6919202270004707,
                                "volume_24h": 0.5861078461304461,
                                "volume_change_24h": 0.99768457946417,
                                "percent_change_1h": 0.35112204426058247,
                                "percent_change_24h": 0.6873797222273095,
                                "percent_change_7d": 0.10436641270012026,
                                "percent_change_30d": 0.287114141886907,
                                "market_cap": 0.34927034860890926,
                                "market_cap_dominance": 2144,
                                "fully_diluted_market_cap": 0.7441638489427347,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.6919202270004707,
                                "volume_24h": 0.5861078461304461,
                                "volume_change_24h": 0.99768457946417,
                                "percent_change_1h": 0.35112204426058247,
                                "percent_change_24h": 0.6873797222273095,
                                "percent_change_7d": 0.10436641270012026,
                                "percent_change_30d": 0.287114141886907,
                                "market_cap": 0.34927034860890926,
                                "market_cap_dominance": 2144,
                                "fully_diluted_market_cap": 0.7441638489427347,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.6919202270004707,
                                "volume_24h": 0.5861078461304461,
                                "volume_change_24h": 0.99768457946417,
                                "percent_change_1h": 0.35112204426058247,
                                "percent_change_24h": 0.6873797222273095,
                                "percent_change_7d": 0.10436641270012026,
                                "percent_change_30d": 0.287114141886907,
                                "market_cap": 0.34927034860890926,
                                "market_cap_dominance": 2144,
                                "fully_diluted_market_cap": 0.7441638489427347,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.6919202270004707,
                                "volume_24h": 0.5861078461304461,
                                "volume_change_24h": 0.99768457946417,
                                "percent_change_1h": 0.35112204426058247,
                                "percent_change_24h": 0.6873797222273095,
                                "percent_change_7d": 0.10436641270012026,
                                "percent_change_30d": 0.287114141886907,
                                "market_cap": 0.34927034860890926,
                                "market_cap_dominance": 2144,
                                "fully_diluted_market_cap": 0.7441638489427347,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.6919202270004707,
                                "volume_24h": 0.5861078461304461,
                                "volume_change_24h": 0.99768457946417,
                                "percent_change_1h": 0.35112204426058247,
                                "percent_change_24h": 0.6873797222273095,
                                "percent_change_7d": 0.10436641270012026,
                                "percent_change_30d": 0.287114141886907,
                                "market_cap": 0.34927034860890926,
                                "market_cap_dominance": 2144,
                                "fully_diluted_market_cap": 0.7441638489427347,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.6919202270004707,
                                "volume_24h": 0.5861078461304461,
                                "volume_change_24h": 0.99768457946417,
                                "percent_change_1h": 0.35112204426058247,
                                "percent_change_24h": 0.6873797222273095,
                                "percent_change_7d": 0.10436641270012026,
                                "percent_change_30d": 0.287114141886907,
                                "market_cap": 0.34927034860890926,
                                "market_cap_dominance": 2144,
                                "fully_diluted_market_cap": 0.7441638489427347,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.6919202270004707,
                                "volume_24h": 0.5861078461304461,
                                "volume_change_24h": 0.99768457946417,
                                "percent_change_1h": 0.35112204426058247,
                                "percent_change_24h": 0.6873797222273095,
                                "percent_change_7d": 0.10436641270012026,
                                "percent_change_30d": 0.287114141886907,
                                "market_cap": 0.34927034860890926,
                                "market_cap_dominance": 2144,
                                "fully_diluted_market_cap": 0.7441638489427347,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    }
                ],
                "XRP": [
                    {
                        "id": 8970,
                        "name": "fnppfrhj6a8",
                        "symbol": "XRP",
                        "slug": "acj3saq51gg",
                        "is_active": 2061,
                        "is_fiat": null,
                        "circulating_supply": 5336,
                        "total_supply": 7415,
                        "max_supply": 7051,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 8856,
                        "cmc_rank": 7685,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "pklfdio7xn",
                            "afztukpqwg",
                            "op9gbmo67sd",
                            "ik3u60u38dh",
                            "ktg1ad5hxch",
                            "a7xhadk0jj6",
                            "smfftpjb97s",
                            "3v5p4pb1hle",
                            "hmgcj9p0b9i",
                            "lbt1pp39dga"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.48538548812790894,
                                "volume_24h": 0.3863552254624678,
                                "volume_change_24h": 0.32522085957265223,
                                "percent_change_1h": 0.541805831297667,
                                "percent_change_24h": 0.9675995326953413,
                                "percent_change_7d": 0.1423201977312738,
                                "percent_change_30d": 0.6782978170068072,
                                "market_cap": 0.49035643986337196,
                                "market_cap_dominance": 7326,
                                "fully_diluted_market_cap": 0.523940831499051,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.48538548812790894,
                                "volume_24h": 0.3863552254624678,
                                "volume_change_24h": 0.32522085957265223,
                                "percent_change_1h": 0.541805831297667,
                                "percent_change_24h": 0.9675995326953413,
                                "percent_change_7d": 0.1423201977312738,
                                "percent_change_30d": 0.6782978170068072,
                                "market_cap": 0.49035643986337196,
                                "market_cap_dominance": 7326,
                                "fully_diluted_market_cap": 0.523940831499051,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.48538548812790894,
                                "volume_24h": 0.3863552254624678,
                                "volume_change_24h": 0.32522085957265223,
                                "percent_change_1h": 0.541805831297667,
                                "percent_change_24h": 0.9675995326953413,
                                "percent_change_7d": 0.1423201977312738,
                                "percent_change_30d": 0.6782978170068072,
                                "market_cap": 0.49035643986337196,
                                "market_cap_dominance": 7326,
                                "fully_diluted_market_cap": 0.523940831499051,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.48538548812790894,
                                "volume_24h": 0.3863552254624678,
                                "volume_change_24h": 0.32522085957265223,
                                "percent_change_1h": 0.541805831297667,
                                "percent_change_24h": 0.9675995326953413,
                                "percent_change_7d": 0.1423201977312738,
                                "percent_change_30d": 0.6782978170068072,
                                "market_cap": 0.49035643986337196,
                                "market_cap_dominance": 7326,
                                "fully_diluted_market_cap": 0.523940831499051,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.48538548812790894,
                                "volume_24h": 0.3863552254624678,
                                "volume_change_24h": 0.32522085957265223,
                                "percent_change_1h": 0.541805831297667,
                                "percent_change_24h": 0.9675995326953413,
                                "percent_change_7d": 0.1423201977312738,
                                "percent_change_30d": 0.6782978170068072,
                                "market_cap": 0.49035643986337196,
                                "market_cap_dominance": 7326,
                                "fully_diluted_market_cap": 0.523940831499051,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.48538548812790894,
                                "volume_24h": 0.3863552254624678,
                                "volume_change_24h": 0.32522085957265223,
                                "percent_change_1h": 0.541805831297667,
                                "percent_change_24h": 0.9675995326953413,
                                "percent_change_7d": 0.1423201977312738,
                                "percent_change_30d": 0.6782978170068072,
                                "market_cap": 0.49035643986337196,
                                "market_cap_dominance": 7326,
                                "fully_diluted_market_cap": 0.523940831499051,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.48538548812790894,
                                "volume_24h": 0.3863552254624678,
                                "volume_change_24h": 0.32522085957265223,
                                "percent_change_1h": 0.541805831297667,
                                "percent_change_24h": 0.9675995326953413,
                                "percent_change_7d": 0.1423201977312738,
                                "percent_change_30d": 0.6782978170068072,
                                "market_cap": 0.49035643986337196,
                                "market_cap_dominance": 7326,
                                "fully_diluted_market_cap": 0.523940831499051,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 2499,
                        "name": "tuxfjexchmd",
                        "symbol": "XRP",
                        "slug": "ykfzucj83n8",
                        "is_active": 3342,
                        "is_fiat": null,
                        "circulating_supply": 3596,
                        "total_supply": 4303,
                        "max_supply": 7375,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 5713,
                        "cmc_rank": 3788,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "c87h6xfqyz",
                            "kgyqdftq20m",
                            "vxjn5gz5cwn",
                            "awrzkzvtaql",
                            "uf5i3x3fwfd",
                            "xaofmxwlqwb",
                            "y2elmkufcq",
                            "oazcxbm4fy",
                            "rz7f6ifp0y",
                            "fy6cwtfiqhv"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.052816716073007974,
                                "volume_24h": 0.011239706566199326,
                                "volume_change_24h": 0.7718863240437461,
                                "percent_change_1h": 0.26600808063032755,
                                "percent_change_24h": 0.2557967607734337,
                                "percent_change_7d": 0.6096738099320835,
                                "percent_change_30d": 0.9610960685576688,
                                "market_cap": 0.10962003005587007,
                                "market_cap_dominance": 6285,
                                "fully_diluted_market_cap": 0.09984393672776104,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.052816716073007974,
                                "volume_24h": 0.011239706566199326,
                                "volume_change_24h": 0.7718863240437461,
                                "percent_change_1h": 0.26600808063032755,
                                "percent_change_24h": 0.2557967607734337,
                                "percent_change_7d": 0.6096738099320835,
                                "percent_change_30d": 0.9610960685576688,
                                "market_cap": 0.10962003005587007,
                                "market_cap_dominance": 6285,
                                "fully_diluted_market_cap": 0.09984393672776104,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.052816716073007974,
                                "volume_24h": 0.011239706566199326,
                                "volume_change_24h": 0.7718863240437461,
                                "percent_change_1h": 0.26600808063032755,
                                "percent_change_24h": 0.2557967607734337,
                                "percent_change_7d": 0.6096738099320835,
                                "percent_change_30d": 0.9610960685576688,
                                "market_cap": 0.10962003005587007,
                                "market_cap_dominance": 6285,
                                "fully_diluted_market_cap": 0.09984393672776104,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.052816716073007974,
                                "volume_24h": 0.011239706566199326,
                                "volume_change_24h": 0.7718863240437461,
                                "percent_change_1h": 0.26600808063032755,
                                "percent_change_24h": 0.2557967607734337,
                                "percent_change_7d": 0.6096738099320835,
                                "percent_change_30d": 0.9610960685576688,
                                "market_cap": 0.10962003005587007,
                                "market_cap_dominance": 6285,
                                "fully_diluted_market_cap": 0.09984393672776104,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.052816716073007974,
                                "volume_24h": 0.011239706566199326,
                                "volume_change_24h": 0.7718863240437461,
                                "percent_change_1h": 0.26600808063032755,
                                "percent_change_24h": 0.2557967607734337,
                                "percent_change_7d": 0.6096738099320835,
                                "percent_change_30d": 0.9610960685576688,
                                "market_cap": 0.10962003005587007,
                                "market_cap_dominance": 6285,
                                "fully_diluted_market_cap": 0.09984393672776104,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.052816716073007974,
                                "volume_24h": 0.011239706566199326,
                                "volume_change_24h": 0.7718863240437461,
                                "percent_change_1h": 0.26600808063032755,
                                "percent_change_24h": 0.2557967607734337,
                                "percent_change_7d": 0.6096738099320835,
                                "percent_change_30d": 0.9610960685576688,
                                "market_cap": 0.10962003005587007,
                                "market_cap_dominance": 6285,
                                "fully_diluted_market_cap": 0.09984393672776104,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.052816716073007974,
                                "volume_24h": 0.011239706566199326,
                                "volume_change_24h": 0.7718863240437461,
                                "percent_change_1h": 0.26600808063032755,
                                "percent_change_24h": 0.2557967607734337,
                                "percent_change_7d": 0.6096738099320835,
                                "percent_change_30d": 0.9610960685576688,
                                "market_cap": 0.10962003005587007,
                                "market_cap_dominance": 6285,
                                "fully_diluted_market_cap": 0.09984393672776104,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    },
                    {
                        "id": 4240,
                        "name": "y2w7aitdec",
                        "symbol": "XRP",
                        "slug": "5h83tuwyn5l",
                        "is_active": 6164,
                        "is_fiat": null,
                        "circulating_supply": 8027,
                        "total_supply": 5567,
                        "max_supply": 7267,
                        "date_added": "2022-05-30T09:50:13.739Z",
                        "num_market_pairs": 3536,
                        "cmc_rank": 4465,
                        "last_updated": "2022-05-30T09:50:13.739Z",
                        "tags": [
                            "i4shqgw87p8",
                            "vpc4jfrbh6",
                            "lweifd03j0c",
                            "jo02htc19wk",
                            "mlm1f20i13",
                            "irjy7nq3de7",
                            "lr0n3x718v",
                            "dof8dqwumaq",
                            "iht3xnzf77q",
                            "rvtz5qfjdog"
                        ],
                        "platform": null,
                        "self_reported_circulating_supply": null,
                        "self_reported_market_cap": null,
                        "quote": {
                            "AUD": {
                                "price": 0.1246062937046668,
                                "volume_24h": 0.16998349976326055,
                                "volume_change_24h": 0.08040942296718723,
                                "percent_change_1h": 0.21525824444423036,
                                "percent_change_24h": 0.6614772727918885,
                                "percent_change_7d": 0.8190223350657431,
                                "percent_change_30d": 0.6341987674368599,
                                "market_cap": 0.749675249730255,
                                "market_cap_dominance": 8304,
                                "fully_diluted_market_cap": 0.6643330759540618,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "BRL": {
                                "price": 0.1246062937046668,
                                "volume_24h": 0.16998349976326055,
                                "volume_change_24h": 0.08040942296718723,
                                "percent_change_1h": 0.21525824444423036,
                                "percent_change_24h": 0.6614772727918885,
                                "percent_change_7d": 0.8190223350657431,
                                "percent_change_30d": 0.6341987674368599,
                                "market_cap": 0.749675249730255,
                                "market_cap_dominance": 8304,
                                "fully_diluted_market_cap": 0.6643330759540618,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "CAD": {
                                "price": 0.1246062937046668,
                                "volume_24h": 0.16998349976326055,
                                "volume_change_24h": 0.08040942296718723,
                                "percent_change_1h": 0.21525824444423036,
                                "percent_change_24h": 0.6614772727918885,
                                "percent_change_7d": 0.8190223350657431,
                                "percent_change_30d": 0.6341987674368599,
                                "market_cap": 0.749675249730255,
                                "market_cap_dominance": 8304,
                                "fully_diluted_market_cap": 0.6643330759540618,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "EUR": {
                                "price": 0.1246062937046668,
                                "volume_24h": 0.16998349976326055,
                                "volume_change_24h": 0.08040942296718723,
                                "percent_change_1h": 0.21525824444423036,
                                "percent_change_24h": 0.6614772727918885,
                                "percent_change_7d": 0.8190223350657431,
                                "percent_change_30d": 0.6341987674368599,
                                "market_cap": 0.749675249730255,
                                "market_cap_dominance": 8304,
                                "fully_diluted_market_cap": 0.6643330759540618,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "GBP": {
                                "price": 0.1246062937046668,
                                "volume_24h": 0.16998349976326055,
                                "volume_change_24h": 0.08040942296718723,
                                "percent_change_1h": 0.21525824444423036,
                                "percent_change_24h": 0.6614772727918885,
                                "percent_change_7d": 0.8190223350657431,
                                "percent_change_30d": 0.6341987674368599,
                                "market_cap": 0.749675249730255,
                                "market_cap_dominance": 8304,
                                "fully_diluted_market_cap": 0.6643330759540618,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "MXN": {
                                "price": 0.1246062937046668,
                                "volume_24h": 0.16998349976326055,
                                "volume_change_24h": 0.08040942296718723,
                                "percent_change_1h": 0.21525824444423036,
                                "percent_change_24h": 0.6614772727918885,
                                "percent_change_7d": 0.8190223350657431,
                                "percent_change_30d": 0.6341987674368599,
                                "market_cap": 0.749675249730255,
                                "market_cap_dominance": 8304,
                                "fully_diluted_market_cap": 0.6643330759540618,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            },
                            "USD": {
                                "price": 0.1246062937046668,
                                "volume_24h": 0.16998349976326055,
                                "volume_change_24h": 0.08040942296718723,
                                "percent_change_1h": 0.21525824444423036,
                                "percent_change_24h": 0.6614772727918885,
                                "percent_change_7d": 0.8190223350657431,
                                "percent_change_30d": 0.6341987674368599,
                                "market_cap": 0.749675249730255,
                                "market_cap_dominance": 8304,
                                "fully_diluted_market_cap": 0.6643330759540618,
                                "last_updated": "2022-05-30T09:50:13.739Z"
                            }
                        }
                    }
                ]
            };

            console.log('cryptoData on Load', cryptoData);

            function ajaxLoadRates (cryptoMain = 'BTC', fiatMain = 'USD') {

                const data = {
                    action: 'get_rates',
                };

                $.ajax({
                    url: ajaxurl,
                    type: 'POST',
                    data: data,
                    success: function(response) {
                        const res = JSON.parse(response)
                        if (!res.status.error_code) {
                            const rate = res.data[cryptoMain][0].quote[fiatMain].price.toFixed(2);

                            cryptoData = res.data;

                            console.log('cryptoData on Ajax Call', cryptoData);

                            $('#exchange-crypto-num').trigger('input');
                            $('#exchange-crypto-num-auto').trigger('input');

                            /* Change Current Rate */
                            $('.js-rate').fadeOut();
                            $('.js-rate').text(`\$${rate}`);
                            $('.js-rate').fadeIn();

                            $('.js-updated-at').text(formatAMPM(new Date))
                        } else {
                            console.error(res.status.error_message)
                            // alert(res.status.error_message)
                        }
                    },
                    error: function (request, status, error) {
                        console.log(request, status, error);
                    }
                });

            };

            /* Init Main Currencies */
            const cryptoMain = $('#exchange-crypto option').eq(0).val();
            const fiatMain = $('#exchange-fiat option').eq(0).val();

            let cryptoOption = $('#exchange-crypto').val();
            let fiatOption = $('#exchange-fiat').val();
            let fiatAutoOption = $('#exchange-fiat-auto').val();

            /* Register Input Events */

            /* Conversation Calculator */
            $('#exchange-crypto-num').on('input', function () {
                const rate = cryptoData[cryptoOption][0].quote[fiatOption].price;
                const result = $(this).val() * rate;
                $('#exchange-fiat-num').val(result.toFixed(2));
            });

            $('#exchange-fiat-num').on('input', function () {
                const rate = cryptoData[cryptoOption][0].quote[fiatOption].price;
                const result = $(this).val() / rate;
                $('#exchange-crypto-num').val(result.toFixed(8));
            });

            $('#exchange-crypto').on('change', function () {
                cryptoOption = $(this).val();
                $('#exchange-crypto-num').trigger('input');
            });

            $('#exchange-fiat').on('change', function () {
                fiatOption = $(this).val();
                $('#exchange-crypto-num').trigger('input');
            });

            /* Calculate Rate on Load */
            $('#exchange-crypto-num').val(1).trigger('input');


            /* Automatic Conversation Calculator */
            $('#exchange-fiat-num-auto').on('input', function () {
                const rate = cryptoData['BTC'][0].quote[fiatAutoOption].price;
                const result = $(this).val() / rate;
                const receive = $(this).val() * 0.99;
                $('#exchange-crypto-num-auto').val(result.toFixed(8));

                if (isInt(receive)) {
                    $('#fiat-num-receive').val(receive);
                } else {
                    $('#fiat-num-receive').val(receive.toFixed(2));
                }

            });

            $('#exchange-fiat-auto').on('change', function () {
                fiatAutoOption = $(this).val();
                $('#exchange-fiat-num-auto').trigger('input');
                $('#fiat-receive').val($(this).val());
            });

            /* Calculate Automatic Rate on Load */
            $('#exchange-fiat-num-auto').val(100).trigger('input');

            /* Call Request evert Minute */
            const requestRates = setInterval(function(){
                ajaxLoadRates(cryptoMain, fiatMain);
            }, 60000);

        }

    });
})(jQuery, window);